/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect, memo, useRef } from "react";

import Cookies from "js-cookie";
import * as FaIcons from "react-icons/fa";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router";
import { IoEyeOutline } from "react-icons/io5";
import { FaPlus, FaMinus } from "react-icons/fa6";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import {
  getDatabase,
  ref,
  onValue,
  // onChildAdded,
  // onChildChanged,
  // onChildRemoved,
} from "firebase/database";
// import { cleanValue } from "react-currency-input-field";

import NDAModel from "./NDAModel.jsx";
import BestBidModal from "./BestBidModal.jsx";
import ForeclosureView from "./ForeclosureView.jsx";
import BidAlertTextModal from "./BidAlertTextModal.jsx";
import { useUserConnections } from './useUserConnections';
import CountdownTimer from "../pdpComponents/CountdownTimer.jsx";
import BidHistoryModal from "../../../components/user/MyBids/BidHistory/BidHistoryModal.jsx";
// import PlaceBestBidModal from "./PlaceBestBidModal.jsx";

import LoadingText from "@/components/loader/LoadingText.jsx";
import LoadedText from "@/components/loader/LoadedText.jsx";
import PDPSaveModal from "../pdpComponents/PDPSaveModal.jsx";
import ConfirmOffer from "@/components/user/MyBids/ConfirmOffer/ConfirmOffer.jsx";

// import { getBidDepositDetail } from "@/api/bid";
// import { getUserProfile } from "@/api/myProfile.js";
import { getPDPInitData } from "@/api/PDP";
import { getBidHistory } from "@/api/bids";
import { isValidSession } from "@/api/auth";
import { isPhoneNoVerified } from "@/api/bid";
import { sendVerificationCode } from "@/api/LoginSignup";
import { onSavePress, onUnsavePress } from "@/api/srpFilter.js";
import { getCommercialWatchProperty } from "@/api/bidDepositApiHold";
import { getCMS, getUserAction, isUserAuthorised, getLatestBidCenter, getBidCenterDetails } from "@/api/PDP";

// import { store } from "@/store/store";
// import { setPDPSaved } from './../../redux/pdp/pdpActions';
// import { setProfileInfo } from "@/redux/user/userSlice.js";
// import { saveProperty, unsaveProperty } from 'src/redux/saved/savedActions';
import { globalCmsData } from "@/redux/cms/cmsSelectors";
import { showOtpModal } from "@/redux/otpModal/otpModalSlice";
import {  setIsCifCompletedForPACT } from "@/redux/PDP/pdpSlice";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
  setShowSessionMsg,
} from "@/redux/login/loginSlice";
import {
  setIsOtpVerificationModalRequired,
  // setIsUserSubscribed,
  // setSubscribeEmailAlreadyExists,
} from "@/redux/login/loginSlice";
import {
  // fetchPDPBidCenterData,
  // fetchPDPInitialLoad,
  // fetchPDPLatestBidCenterData,
  fetchPDPBidCenterDataSuccess,
} from "@/redux/PDP/pdpSlice";
import {
  enableOwnItNow,
  setSelectedBidAmount,
  updateSaveProperty,
  setAuctionDetails,
  setRedirectionAction,
  setIsNDAAccepted,
  setRedirectionAmount,
  setOfferData,
  setPdpError,
} from "@/redux/PDP/pdpSlice";
import {
  setIsAddedToSaved,
  showSavedTooltip,
} from "@/redux/savedpreference/savedPreferenceSlice.js";

import {
  inititaliseFirebase,
  // deattachListeners,
} from "@/components/common/FirebaseApp";

import {
  currencyFormatNew,
  //  isLessThan15MinutesLeft
} from "../pdpComponents/utils.jsx";
import { parseAutoExtendConfig } from "@/utils/autoExtendConfig";
import { trackApiCall, trackButtonClick, trackPageMount } from "@/utils/analytics.js";
import { getPropertyURL } from "@/utils/propertyNavigation.js";

// const centerDivStyle = {
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

const BidCenter = ({
  data,
  statusPayload,
  navigation,
  pdpBidCenter,
  pdpData,
  financialType,
  listingType,
  status,
  offerType,
  offerCenterDetail,
  isFcOnlineFlag,
  pdpPropertyFees,
  isWatchProperty,
  caFcSalePropertyDetails,
  isCAFCSaleProperty,
  useModalForSave = false,
  onSaveModalChange,
}) => {
  const {
    isUnderReview,
    isTraditional,
    isPreview,
    isUnderContractAuction,
    isUnderContractTraditional,
    isHNBTraditional,
    isShortSaleUnderContractAuction,
    isShortSaleUnderContractTraditional,
    isUnderReviewAuction,
    isShortSaleUnderReview,
    isForeclosure,
  } = statusPayload;

  // const isUserLoggedIn = useSelector((state) => state.user.isUserLoggedIn);

  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);

  const autoExtendConfig = parseAutoExtendConfig(pdpInitData?.propertySpecialDetails);

  const isNDAAccepted = useSelector((state) => state.pdp.isNDAAccepted);

  const { propertyId, detailedAttributes, commonAttributes, address } =
    pdpData?.propertyDetails;

  const isCashOnly = financialType?.length === 1 && financialType[0] === "CASH";
  // const currentSavedProperties = useSelector(
  //   (state) => state.saved?.savedProperties
  // );
  // const userData = useSelector((state) => state.auth?.registration);
  const onWatchList = useSelector((state) => state.pdp?.pdpInitData?.propertySpecialDetails?.onWatchList);
  const redirectionAction = useSelector((state) => state.pdp?.redirectionAction);
  const redirectionAmount = useSelector((state) => state.pdp?.redirectionAmount);

  const user = useSelector((state) => state.user);
  // const user_info = useSelector((state) => state?.user?.user);
  const { isUserSubscribed } = useSelector((state) => state.login);
  const [showModal, setShowModal] = useState(false);

  // Notify parent when save modal visibility changes (for rendering outside overflow:hidden containers)
  useEffect(() => {
    if (onSaveModalChange) onSaveModalChange(showModal);
  }, [showModal, onSaveModalChange]);

  // const [showBidDeposit, setBidDepositShow] = useState(false);
  // const [showCashOnly, setShowCashOnly] = useState(false);
  const [isVerificationGoing, setIsVerificationGoing] = useState(false);
  const [isVerificationGoingForOwnitNow, setIsVerificationGoingForOwnitNow] =
    useState(false);

  const { propCategory } = commonAttributes;
  const { isPrelistAsset, apnTaxId, isAllowedPreSale } = detailedAttributes;
  const isPreviewProperty = isAllowedPreSale !== null && isAllowedPreSale;
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [showOfferAlert, setShowOfferAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  // const isTraditional =  listingType === "TRNL";

  // console.log(
  //   "pdpInitData?.listingDetail?.listingId",
  //   pdpInitData?.propertyDetails?.listingId
  // );

  const latestBidCenterData = useSelector(
    (state) => state.pdp?.latestBidCenterData
  );

  // const featureCMSData = useSelector(state => state.featureConf.featureCMSData);

  const ownItNowEnabled = pdpInitData?.listingDetail?.ownItNowFlag;
  const countyBiddingEnabled = pdpInitData?.countyBiddingEnabled;
  const [showBidHistory, setShowBidHistory] = useState(false);

  // const [showReserveMet, setReserveMet] = useState(false);
  // const [buyerAmountInfo, setBuyerAmountInfo] = useState({});
  // const isScheduled = commonAttributes?.status === "SCHEDULED" ? true : false;
  const [showDynamicBiddingPopUp, setShowDynamicBiddingPopUp] = useState(false);
  // ! add state for place best bid
  const [showBestBidModal, setShowBestBidModal] = useState(false);
  const [openConfirmOffer, setOpenConfirmOffer] = useState(false);
  const profileInfo = useSelector((state) => state.user.user);




  const [showNDA, setShowNDA] = useState(false);
  // const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  //  const { isUserLoggedIn, userName, userSignOut, userLastName } = useAuth();

  //   const icon =
  //     onWatchList && userData?.user?.userEmailId ? Icons.HeartFilled : Icons.Heart;
  const navigate = useNavigate();


  const isFcOnlineProp =
    isFcOnlineFlag != undefined && isFcOnlineFlag === "Y" ? true : false;

  const bidCenterData = useSelector((state) => state.pdp.bidCenterData);
  const auctionDetails = useSelector((state) => state.pdp.auctionDetails);

  // const [bidCenterData, setBidCenterData] =  useState(bidCenterDataRedux);

  const bestBidAvailable =
    bidCenterData?.bestBidAvailable && profileInfo !== null ? true : false;
  const undercontractOffer = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };
  const underReviewData = {
    header: pdpBidCenter?.underreview,
    content: pdpBidCenter?.underreviewdesc,
  };
  const previewData = {
    header: pdpBidCenter?.previewPropertyContent?.previewPropertyHeader,
    content: pdpBidCenter?.previewPropertyContent?.previewPropertyContent,
  };
  const underContractAuctionData = {
    header: pdpBidCenter?.undercontractAuction,
    content: pdpBidCenter?.undercontractdesc,
  };
  const underContractTraditionalData = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };
  const hNBTraditionalData = {
    header: pdpBidCenter?.hnbended,
    content: pdpBidCenter?.undercontractofferhnbdesc,
  };
  const shortSaleUnderContractTraditionalData = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };
  const hasHnbData = {
    header: pdpBidCenter?.hnbended,
    content: pdpBidCenter?.undercontractofferhnbdesc,
  };
  const isShortSaleUnderContractAuctionData = {
    content: pdpBidCenter?.undercontractdescShortSale,
  };

  const fcOnlineAuctionEventEnded = {
    header: pdpBidCenter?.pdpFcOnline?.auctionEventEnded,
    content: pdpBidCenter?.pdpFcOnline?.auctionEventEndedSubTxt,
  };
  const shouldShowCashOnly =
    status === "SPND" &&
      offerType !== "PLACE_OFFER" &&
      offerType !== "PLACE_BACKUP_OFFER" &&
      offerType !== "WATCH_PROPERTY" &&
      !isWatchProperty &&
      !bidCenterData?.bestBidAvailable &&
      !bidCenterData?.sellerFinalNegotiationResponse
        ?.sellerFinalNegotiationAvailable &&
      (isUnderReviewAuction ||
        isUnderContractAuction ||
        statusPayload.hasHnb === "Y") &&
      latestBidCenterData.placeBackupBidButton === true
      ? true
      : status === "SPND"
        ? false
        : true;

  let hnbDeadlnDt = [];
  let higherstBidTerms = {};
  if (statusPayload?.hnbDeadlnDt) {
    hnbDeadlnDt = statusPayload.hnbDeadlnDt.split(" ");

    let date = `${hnbDeadlnDt[1]} ${hnbDeadlnDt[2]} on ${hnbDeadlnDt[0]}`;

    higherstBidTerms = {
      header: pdpBidCenter?.hnbrequestedtitle,
      content: pdpBidCenter?.hnbdesc?.replace("###DATE###", date),
    };
  }
  // const state = store.getState();
  const userID = profileInfo?.realbidUserId;
  const [prevBidCount, setPrevBidCount] = useState(0);
  // const [onlineUsersCount, setOnlineUsersCount] = useState(0);
  // const [prevOnlineUsersCount, setPrevOnlineUsersCount] = useState(0);



  const [bidIncrementCount, setBidIncrementCount] = useState(Number(0));
  const [bidAmount, setBidAmount] = useState(
    auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
      latestBidCenterData?.nextpossibleBidAmount &&
      Number(auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount)
  );

  // Update bid amount when latestBidCenterData loads (fallback for when Firebase/auctionDetails is not available)
  useEffect(() => {
    if (!bidAmount && latestBidCenterData?.nextpossibleBidAmount) {
      setBidAmount(latestBidCenterData.nextpossibleBidAmount);
    }
  }, [latestBidCenterData?.nextpossibleBidAmount]);

  const isFinancing =
    (pdpInitData?.listingDetail?.financialType?.length === 1 && pdpInitData?.listingDetail?.financialType.includes('MORTGAGE')) ||
    (pdpInitData?.listingDetail?.financialType?.length === 2 &&
      pdpInitData?.listingDetail?.financialType.includes('MORTGAGE') &&
      pdpInitData?.listingDetail?.financialType.includes('CASH') &&
      data?.pdpStaticContent[[propCategory]]?.conditionBased?.mortgage
        ?.staticContentHead);

  // const [offerAmount, setOfferAmount] = useState(redirectionAmount ? redirectionAmount : "");
  const [validationError, setvalidationError] = useState("");
  // const [error, setError] = useState(null);
  const [cmsErrorMessages, setCmsErrorMessages] = useState();

  const [activeConfigData, setActiveConfigData] = useState([]);
  const [bidHistory, setBidHistory] = useState();
  const [bidActionType, setBidActionType] = useState("")
  // const firebaseConfig = useSelector((state) => state.user?.firebaseConfig);

  // const [isNDAAcceptedLocal, setIsNDAAcceptedLocal] = useState(isNDAAccepted);
  const pdpError = useSelector((state) => state.pdp.pdpError);

  const isOfferApproved = offerCenterDetail?.listingStatus === "CLOSED" &&
    offerCenterDetail?.currentHighestOffer !== null
  const cifCompleted = useSelector((state) => state.pdp.isCifCompletedForPACT);

  const pdpGlobalCmsData = useSelector(globalCmsData);



  const isFcAcutionEventEnded = (isUnderContractAuction || isShortSaleUnderContractAuction) && isFcOnlineProp
  const showBid =
    // isFcOnlineFlag !== "Y" ||
    // (propCategory !== "FORECLOSURE" &&
    isPrelistAsset !== "PREVIEW" &&
    listingType !== "TRNL" &&
    !isFcAcutionEventEnded
    ;


  //   var activeConfigData = featureCMSData?.activeBidConfig
  //   ? featureCMSData.activeBidConfig
  //   : activeConfigCms;
  // const actConfig = featureCMSData?.activeBidConfig
  //   ? featureCMSData?.activeBidConfig
  //   : activeConfigCms;

  let buttonLabel = "-";

  let nextpossibleBidAmount = 0;
  let biddingIncrementalAmount = 0;
  let incrementMultiplier = 0;
  let maximumPossibleBidAmount = 0;
  let bidMinLimit = 0;
  let bidMaxLimit = 0;
  let bidMaxLength = 0;
  let lowerThresholdAmount = 0;
  let lowerThresholdIncrementMultiplier = 0;
  let upperThresholdAmount = 0;
  let upperThresholdIncrementMultiplier = 0;
  let offerMinLimit = 0;
  let offerMaxLimit = 0;
  let customBidIncrementMultiplier = 0;
  if (bidCenterData && latestBidCenterData) {
    customBidIncrementMultiplier = bidCenterData?.customBidIncrementMultiplier;
    biddingIncrementalAmount = bidCenterData?.biddingIncrementalAmount;
    incrementMultiplier = bidCenterData?.incrementMultiplier;
    maximumPossibleBidAmount = bidCenterData?.maximumPossibleBidAmount;
    nextpossibleBidAmount = auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount : latestBidCenterData.nextpossibleBidAmount;
    lowerThresholdAmount = bidCenterData?.lowerThresholdAmount;
    upperThresholdAmount = bidCenterData?.upperThresholdAmount;
    lowerThresholdIncrementMultiplier =
      bidCenterData?.lowerThresholdIncrementMultiplier;
    upperThresholdIncrementMultiplier =
      bidCenterData.upperThresholdIncrementMultiplier;


    if (
      latestBidCenterData?.highestBidAmount >= upperThresholdAmount &&
      bidCenterData?.activeBidRefinementEnabled === true
    ) {
      bidMinLimit =
        latestBidCenterData?.highestBidAmount + upperThresholdIncrementMultiplier;
      bidMaxLimit = latestBidCenterData?.highestBidAmount + upperThresholdIncrementMultiplier;
    } else if (
      latestBidCenterData?.highestBidAmount >= lowerThresholdAmount &&
      latestBidCenterData?.activeBidRefinementEnabled === true
    ) {
      bidMinLimit =
        latestBidCenterData?.highestBidAmount + lowerThresholdIncrementMultiplier;

      bidMaxLimit = latestBidCenterData?.highestBidAmount + 2 * (lowerThresholdIncrementMultiplier);

    } else if (
      auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount &&
          auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount > 0
    ) {
      bidMinLimit = auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount;
      bidMaxLimit = bidCenterData?.maximumPossibleBidAmount;

    } else {
      bidMinLimit = latestBidCenterData?.highestBidAmount + biddingIncrementalAmount;
      bidMaxLimit = bidCenterData?.maximumPossibleBidAmount;

    }



    if (bidCenterData?.activeBidRefinementEnabled === true && nextpossibleBidAmount <= lowerThresholdAmount) {
      bidMaxLimit = lowerThresholdAmount;

    }
  }

  bidMaxLength = (bidMaxLimit + " ").length + 1;
  if (pdpInitData && pdpInitData.offerCenterDetail) {
    offerMinLimit = pdpInitData.offerCenterDetail.minimumStartingOffer;
    offerMaxLimit = pdpInitData.offerCenterDetail.maximumPermissibleOffer;
  }

  const lowerSlab =
    lowerThresholdAmount > bidCenterData?.currentHighestBid
      ? lowerThresholdAmount
      : bidCenterData?.currentHighestBid + lowerThresholdIncrementMultiplier;

  const upperSlab =
    upperThresholdAmount >= (auctionDetails.nextpossibleBidAmount || latestBidCenterData?.nextpossibleBidAmount)
      ? upperThresholdAmount
      : (auctionDetails.nextpossibleBidAmount || latestBidCenterData?.nextpossibleBidAmount);



  customBidIncrementMultiplier = bidCenterData?.incrementMultiplier;

  // const [lowerSlabAmount, setLowerSlabAmount] = useState("");
  // const [upperSlabAmount, setUpperSlabAmount] = useState("");
  const [hasTimerEnded, setHasTimerEnded] = useState(false);
  const [slabUpdated, setSlabUpdated] = useState(false);
  if (slabUpdated != true) {
    // setLowerSlabAmount(lowerSlab || "");
    // setUpperSlabAmount(upperSlab || "");
    setSlabUpdated(true);
  }

  // const handleClickOutside = (e) => {
  //   if (!e.target.closest('.tooltip-trigger')) {
  //     setIsTooltipOpen(false);
  //   }
  // };

  const dispatch = useDispatch();

  const onSave = async () => {
    if (profileInfo?.userEmailId || isUserSubscribed) {
      if (onWatchList === "Y") {
        dispatch(updateSaveProperty("N"));
        const response = await onUnsavePress({ propertyId });
        if (response === "success") {
          dispatch(setIsAddedToSaved());

          trackApiCall({
            eventName: "favourite_property_unsaved",
            eventCategory: "NEW-PDP",
            eventSource: "pdp_bid_center",
            eventLabel: `Property Id: ${propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: "favourite_property_unsave_error",
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${propertyId}`,
          });
        }
      } else {
        dispatch(updateSaveProperty("Y"));
        const response = await onSavePress({ propertyId });
        if (response === "success") {
          dispatch(showSavedTooltip(true));
          dispatch(setIsAddedToSaved());

          trackApiCall({
            eventName: "favourite_property_saved",
            eventCategory: "NEW-PDP",
            eventSource: "pdp_bid_center",
            eventLabel: `Property Id: ${propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: "favourite_property_save_error",
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${propertyId}`,
          });
        }
      }
    } else {
      setShowModal(true);
    }
  };



  useEffect(() => {


    if (profileInfo.primaryPhone) {

      if ((!pdpError || pdpError?.length === 0) && redirectionAction) {
        onSuccessfullLogin();
      } else {
        refreshAfterLogin();
      }
    }
  }, [profileInfo.primaryPhone]);


  // useEffect(() => {
  //   if (pdpInitData?.propertyDetails?.listingId) {
  //     dispatch(fetchPDPBidCenterData(pdpInitData.propertyDetails.listingId));
  //     dispatch(fetchPDPLatestBidCenterData(pdpInitData.propertyDetails.listingId));
  //   }
  // }, [user?.isUserLoggedIn]);
  const refreshAfterLogin = async () => {
    const details = await getPDPInitData(pdpInitData?.propertyDetails?.listingId);
    if (details?.propertySpecialDetails.onWatchList === 'Y') {
      dispatch(updateSaveProperty("Y"));
    }
  }

  const onSuccessfullLogin = async () => {
    setIsVerificationGoing(true);

    // Handle save action first — doesn't require bid center data
    if (redirectionAction === "handleSave") {
      setIsVerificationGoing(false);
      dispatch(updateSaveProperty("Y"));
      const response = await onSavePress({ propertyId });

      if (response === "success") {
         trackApiCall({
          eventName: "favourite_property_saved",
          eventCategory: "NEW-PDP",
          eventSource: "pdp_bid_center",
          eventLabel: `Property Id: ${propertyId}`,
        });
      } else {
          dispatch(updateSaveProperty("N"));

        trackApiCall({
          eventName: "favourite_property_save_error",
          eventCategory: "Error",
          eventSource: `Error - ${
            response?.message || "Data Initialization Failed"
          }`,
          eventLabel: `Property Id: ${propertyId}`,
        });


      }
      dispatch(setRedirectionAction(""));
      return;
    }

    const data = await getBidCenterDetails(pdpInitData?.propertyDetails?.listingId);
    if (data) {
      dispatch(fetchPDPBidCenterDataSuccess(data));
      if (redirectionAction === "handlePlaceBid") {
        if (propCategory === 'COMMERCIAL') {
          const details = await getPDPInitData(pdpInitData?.propertyDetails?.listingId);
          if (details) {
            setIsVerificationGoing(false);


            // setIsNDAAcceptedLocal(details?.ndaCommercialAccepted);
            dispatch(setIsNDAAccepted(details?.ndaCommercialAccepted));
            dispatch(setIsCifCompletedForPACT(details?.cifCompleted));

            if (details?.propertySpecialDetails.onWatchList === 'Y') {
              dispatch(updateSaveProperty("Y"));
            }


            const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
            setIsVerificationGoing(false);
            dispatch(enableOwnItNow(false));

            if (res?.data?.data) {
              if (!(validationError?.length > 0)) {
                const isAuthorised = await isUserAuthorised(
                  pdpInitData?.propertyDetails?.listingId
                );

                if (isAuthorised.message === "USER_NOT_ALLOWED_TO_BID") {
                  setAlertText(
                    "You cannot place another bid as you are the current highest bidder."
                  );
                  setShowAlert(true);
                } else {
                  dispatch(setSelectedBidAmount(bidAmount));


                  if (propCategory === "COMMERCIAL" && status !== "PACT") {

                    if (details?.ndaCommercialAccepted === "N") {
                      if (!document.querySelector('#ndapopmodal')) {
                        setShowNDA(true);
                      }
                      return;

                    } else if (details?.ndaCommercialAccepted === "Y") {
                      dispatch(setRedirectionAction(""));
                      navigate("/bid");
                    }

                  } else {
                    dispatch(setRedirectionAction(""));
                    navigate("/bid");
                  }
                }
              }
            } else {
              const isPhoneVerified = res?.data?.data;

              if (!isPhoneVerified) {
                dispatch(
                  showOtpModal({
                    phoneNumber: profileInfo?.primaryPhone,
                    redirectScreen: "PDP",
                    redirectionRequired: true,
                  })
                );
                dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
              }
            }
          }
        } else {
          setIsVerificationGoing(false);

          hanldePlaceBid(bidActionType)
        }

      } if (redirectionAction === "handleOwnItNow") {
        setIsVerificationGoing(false);

        handleOwnItNow()
      } if (redirectionAction === "placeBackUpOffer") {
        setIsVerificationGoing(false);

        navigateToPlaceBackUpOffer(offerCenterDetail?.listingId)
      } if (redirectionAction === "placeOffer") {
        setIsVerificationGoing(false);

        placeOffer(offerCenterDetail?.listingId)
      }
      dispatch(setRedirectionAction(""));
    }



  };

  // Read CMS data from Redux store (already fetched at app init) to avoid
  // duplicate network requests from multiple bid center components.
  const globalCmsResults = useSelector(
    (state) => state.cms?.data?.global?.results?.[0]
  );

  useEffect(() => {
    if (globalCmsResults) {
      if (globalCmsResults?.appUpdateConfig?.activeBidConfig) {
        setActiveConfigData(globalCmsResults.appUpdateConfig.activeBidConfig);
      }
      if (!cmsErrorMessages && globalCmsResults?.errorMessages) {
        setCmsErrorMessages(globalCmsResults.errorMessages);
      }
    } else {
      // Fallback: fetch from API only if Redux store doesn't have it yet
      getCMS(encodeURI("global/appUpdateConfig/activeBidConfig")).then(
        (response) => {
          setActiveConfigData(response?.results);
        }
      );
      if (!cmsErrorMessages) {
        getCMS("global/errorMessages").then((response) => {
          setCmsErrorMessages(response?.results?.[0]);
        });
      }
    }
    dispatch(setRedirectionAmount(""));

  }, []);

  const firebaseListenerRef = useRef(null);
  const userConnectionsListenerRef = useRef(null);

  // Use the hook at component level
  const visitorId = Cookies.get("visitorId");
  // const env = import.meta.env.VITE_FIREBASE_CONFIG;

  const host = window.location.host;

           let env = ""
           if(host === "preview.hubzu.com") {
            env =  "UAT";
           }else if(host === "hubzu.com" || host === "www.hubzu.com"){
            env =  "PROD";
           }else{
            env =  "INTEG";
           }


  const userConnectionsNodeUrl = pdpGlobalCmsData?.["firebaseConfig"]?.[env]?.dbPath
    ? `${pdpGlobalCmsData["firebaseConfig"][env].dbPath}listings/${pdpInitData?.listingDetail?.businessListingId}/auctionDetails/connections`
    : null;
  useUserConnections(userConnectionsNodeUrl, visitorId, null);


  useEffect(() => {
    if (!firebaseListenerRef.current && pdpGlobalCmsData?.["firebaseConfig"]?.[env]) {

      inititaliseFirebase(pdpGlobalCmsData["firebaseConfig"][env]);

      const db = getDatabase();
      const databaseUrl = pdpGlobalCmsData["firebaseConfig"][env].dbPath + 'listings/' + pdpInitData?.listingDetail?.businessListingId + "/auctionDetails";
      const listingDetailsRef = ref(db, "/" + pdpGlobalCmsData["firebaseConfig"][env].dbPath + 'listings/' + pdpInitData?.listingDetail?.businessListingId);

      firebaseListenerRef.current = onValue(listingDetailsRef, (snapshot) => {
        const data = snapshot.val();

        if (data) {
          if (data?.auctionDetails?.auctionTimeLeft) {

            polLatestBidCenter();


            // const details = await getLatestBidCenter(pdpInitData?.propertyDetails?.listingId);
            //     if (details) {
            //     }
            // dispatch(setAuctionDetails(data?.auctionDetails));
            // if (parseInt(bidAmount) < parseInt(data?.auctionDetails.nextpossibleBidAmount)) {
            //   setBidAmount(data?.auctionDetails.nextpossibleBidAmount);
            // }
          }

          const currentBidCount = data?.auctionDetails?.numberOfBids;
          if (isHotProperty(currentBidCount, prevBidCount) && currentBidCount !== prevBidCount) {
            toast(`Hot Property! ${currentBidCount} bids placed already.`, {
              toastId: `hot-property-${currentBidCount}`,
              className: 'black-toast',
              position: 'bottom-right',
              icon: <img style={{ width: 30, height: 30 }}
                src="/assets/images/hotProperty.png"
                data-tip="Hot Property"
                alt="Hot Property" />,
            });
            trackApiCall({
              eventName: "pdp_toast_messages",
              eventCategory: "NEW-PDP",
              eventSource: "on page mount",
              eventLabel: `Property ID: ${propertyId} | type: pdpviews`
            })
          }
          setPrevBidCount(currentBidCount);

          //  deattachListeners(listingDetailsRef);
        }
      });

      var isAllowedToDsiplayOnlineUsersCount = 'Y';
      var visitorId = Cookies.get("visitorId");

      if (visitorId && isAllowedToDsiplayOnlineUsersCount === 'Y') {
        var userConnectionsNodeUrl = databaseUrl + "/connections";
        const connectionsRef = ref(db, userConnectionsNodeUrl);

        userConnectionsListenerRef.current = onValue(connectionsRef, (snapshot) => {
          const connections = snapshot.val();
          const currentCount = connections ? Object.keys(connections).length : 0;




          if (currentCount > 1) {
            toast(` ${currentCount} others are currently viewing this property.`, {
              className: 'black-toast',
              position: 'bottom-right',
              icon: <IoEyeOutline size="20px" style={{ color: '#118BF4' }} />
            });
            trackApiCall({
              eventName: "pdp_toast_messages",
              eventCategory: "NEW-PDP",
              eventSource: "on page mount",
              eventLabel: `Property ID: ${propertyId} | type: pdpviews`
            })
          }

          // setOnlineUsersCount(currentCount);
          // setPrevOnlineUsersCount(currentCount);
        });


      }

      return () => {
        if (firebaseListenerRef.current) {
          firebaseListenerRef.current();
          firebaseListenerRef.current = null;
        }
        if (userConnectionsListenerRef.current) {
          userConnectionsListenerRef.current();
          userConnectionsListenerRef.current = null;
        }
      };
    }
  }, [userID, pdpGlobalCmsData]);


  const polLatestBidCenter = async () => {
    const details = await getLatestBidCenter(pdpInitData?.propertyDetails?.listingId);
    if (details) {

      dispatch(setAuctionDetails(details));
      if (parseInt(bidAmount) < parseInt(details?.nextpossibleBidAmount)) {
        setBidAmount(details?.nextpossibleBidAmount);
      }
    }
  }


  useEffect(() => {
    if (isHotProperty(auctionDetails.numberOfBids, 0) && auctionDetails.numberOfBids !== 0) {
      toast(`Hot Property! ${auctionDetails.numberOfBids} bids placed already.`, {
        toastId: `hot-property-${auctionDetails.numberOfBids}`,
        className: 'black-toast',
        position: 'bottom-right',
        icon: <img style={{ width: 30, height: 30 }}
          src="/assets/images/hotProperty.png"
          data-tip="Hot Property"
          alt="Hot Property" />,
      });
      trackApiCall({
        eventName: "pdp_toast_messages",
        eventCategory: "NEW-PDP",
        eventSource: "on page mount",
        eventLabel: `Property ID: ${propertyId} | type: pdpviews`
      })
    }
  }, [auctionDetails.numberOfBids])

  useEffect(() => {
    if (isOfferApproved !== undefined && isOfferApproved) {
      trackPageMount({
        pageName: "bid_selected_offer_approved",
        eventCategory: "NEW-PDP",
        eventSource: "on page mount",
        eventLabel: `Property ID: ${propertyId} | type: pdpviews`,
      });
    }
  }, [isOfferApproved]);

  const getData = () => {
    switch (listingType) {
      case "TRNL":
        let data = undercontractOffer;
        if (offerType === "PLACE_BACKUP_OFFER") {
          if (
            offerCenterDetail.hasHnB === "Y" &&
            offerCenterDetail.remDeadlineHrs <= 0
          ) {
            if (status !== "SPND") {
              return hNBTraditionalData;
            }
          }
          if (status !== "ACTV") {
            return data;
          }
        } else if (offerType === "WATCH_PROPERTY") {
          return {
            header: pdpBidCenter?.hnbended,
            content: pdpBidCenter?.undercontractofferhnbdescWatch,
          };
        } else if (offerType === "PLACE_OFFER") {
          return higherstBidTerms;
        }
        return data;
      case "AUCN":
        if (status === "WFA" || status === 'WLST' || status === "PIFA") {
          return {
            header: pdpBidCenter?.AUCN?.WFA?.biddingHeader,
            content: pdpBidCenter?.AUCN?.WFA?.description,
          };
        }
        if (status === "SPND") {
          return {
            header: pdpBidCenter?.AUCN?.SPND?.biddingHeader,
            content: pdpBidCenter?.AUCN?.SPND?.description,
          };
        }
        return "";
      default:
        if (isPreview) {
          return previewData;
        }
        if (status === "WFA") {
          return {
            header: pdpBidCenter?.isPreview?.WFA?.header,
            content: pdpBidCenter?.isPreview?.WFA?.content,
          };
        }
        return "";
    }
  };

  const handleNDAccepted = () => {
    setShowNDA(false);
    dispatch(setRedirectionAction(""));
    navigate("/bid");
  };

  const getHeader = () => {
    return (
      <h3 className="text-center bid-heading-ends pb20">
        {isUnderReviewAuction && underReviewData.header}
        {isShortSaleUnderContractTraditional &&
          shortSaleUnderContractTraditionalData.header}
        {isUnderReview && !isUnderReviewAuction && underReviewData.header}
        {isPreview && previewData.header}
        {(isUnderContractAuction || isShortSaleUnderContractAuction) &&
          isFcOnlineProp &&
          fcOnlineAuctionEventEnded.header}
        {(isUnderContractAuction || isShortSaleUnderContractAuction) &&
          !isFcOnlineProp &&
          underContractAuctionData.header}
        {isUnderContractTraditional &&
          statusPayload.hasHnb !== "Y" &&
          underContractTraditionalData.header}
        {isHNBTraditional && hNBTraditionalData.header}
        {statusPayload.hasHnb === "Y" &&
          !isHNBTraditional &&
          !isUnderReview &&
          !isPreview &&
          !isUnderContractAuction &&
          !isShortSaleUnderContractAuction &&
          !isShortSaleUnderContractTraditional &&
          hasHnbData.header}
      </h3>
    );
  };

  const getContent = () => {
    return (
      <p
        size={15}
        lh={22}
        color={"black"}
        style={{ marginBottom: 30 }}
        className="pdp-get-content"
      >
        {isUnderReview &&
          isUnderReviewAuction &&
          isShortSaleUnderReview &&
          !bestBidAvailable &&
          underReviewData.content}
        {isUnderReviewAuction &&
          !isShortSaleUnderReview &&
          bestBidAvailable &&
          pdpBidCenter?.placeBestBidLabel.underreviewBestBid}

        {isUnderReviewAuction &&
          !bestBidAvailable &&
          !isShortSaleUnderReview &&
          underReviewData.content}

        {isUnderReview &&
          !isUnderReviewAuction &&
          !bestBidAvailable &&
          underReviewData.content}
        {isPreview && previewData.content}
        {isUnderContractAuction &&
          !isShortSaleUnderContractAuction &&
          isFcOnlineProp &&
          fcOnlineAuctionEventEnded.content}
        {isUnderContractAuction &&
          !isShortSaleUnderContractAuction &&
          !isFcOnlineProp &&
          underContractAuctionData.content}
        {isShortSaleUnderContractAuction &&
          isUnderContractAuction &&
          isFcOnlineProp &&
          fcOnlineAuctionEventEnded.content}
        {isShortSaleUnderContractAuction &&
          isUnderContractAuction &&
          !isFcOnlineProp &&
          isShortSaleUnderContractAuctionData.content}
        {isUnderContractTraditional &&
          statusPayload.hasHnb !== "Y" &&
          underContractTraditionalData.content}
        {isHNBTraditional && hNBTraditionalData.content}
        {isShortSaleUnderContractTraditional &&
          shortSaleUnderContractTraditionalData.content}
        {statusPayload.hasHnb === "Y" &&
          !isPreview &&
          !isHNBTraditional &&
          !isUnderReview &&
          !isUnderContractAuction &&
          !isShortSaleUnderContractAuction &&
          !isShortSaleUnderContractTraditional &&
          hasHnbData.content}
      </p>
    );
  };
  const currencyConverter = (currencyValue) => {
    if (currencyValue !== undefined && currencyValue !== "") {
      if (typeof currencyValue === "string") {
        currencyValue = Number(currencyValue);
      }
      let value = currencyValue.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return "$" + value.substring(0, value.indexOf(".") + 0);
    }
    return null;
  };
  const getPrice = () => {
    let result = {
      amount: "",
      label: "",
    };

    if (listingType === "AUCN") {
      if (statusPayload.isActive || statusPayload.isPact) {
        const hasValidTimer = bidCenterData?.auctionTimeLeft !== null;
      }
      if (bidCenterData?.displayListPriceForAuction === "Y") {
        result.amount = currencyConverter(bidCenterData.listingPrice);
        result.label = "Listing Price";
      } else if (bidCenterData?.currentHighestBid === 0) {
        result.amount = currencyConverter(bidCenterData.startingBidAmount);
        result.label = "Starting Bid";
      } else {
        result.amount = currencyConverter(auctionDetails?.highestBidAmount ? auctionDetails?.highestBidAmount : bidCenterData?.currentHighestBid);
        result.label = "Current Highest Bid";
      }
    } else if (listingType === "TRNL") {
      if (
        offerCenterDetail?.currentHighestOffer !== "0" &&
        offerCenterDetail?.currentHighestOffer !== null
      ) {
        result.amount = currencyConverter(
          offerCenterDetail.currentHighestOffer
        );
        result.label = "Current Highest Offer";
      } else if (offerCenterDetail?.listingPrice) {

        if (
          (offerCenterDetail?.currentHighestOffer === '' ||
            offerCenterDetail?.currentHighestOffer === '0' ||
            offerCenterDetail?.currentHighestOffer === 'NA' ||
            statusPayload?.hasHnb === 'Y') &&
          offerCenterDetail?.listingPrice
        ) {
          result.amount = currencyConverter(offerCenterDetail.listingPrice);
          result.label = "Listing Price";

        }

        // result.amount = currencyConverter(offerCenterDetail.listingPrice);
        // result.label = "Listing Price";
      } else {
        result.amount = currencyConverter(
          pdpInitData?.propertySpecialDetails?.listingPrice
        );
        // result.label = 'Current Highest Bid';
        result.label = "Starting Bid";
      }
    } else if (propCategory === "FORECLOSURE") {
      if (estimatedOpeningBid) {
        result.amount = currencyConverter(estimatedOpeningBid);
        result.label = "Estimated Opening Bid";
      } else {
        result.amount = "TBD";
        // result.label = 'Starting Bid';
        result.label = "Estimated Opening Bid";
      }
    }
    // result.amount =
    //   result.amount.indexOf('$') > -1 || result.amount.indexOf('TBD') > -1
    //     ? result.amount
    //     : '$' + result.amount;
    return result;
  };

  const getCTATitle = () => { };
  let errorMessage = null;

  const validateBidMinMaxPriceError = () => {


    // if(biddingIncrementalAmount === undefined) return;
    // Reset errorMessage at the start so the return value reflects actual validation
    errorMessage = null;

    // Safeguard: skip validation if bid center data is not fully loaded
    if (!bidCenterData?.maximumPossibleBidAmount || !latestBidCenterData?.nextpossibleBidAmount) {
      return errorMessage;
    }

    const CHB = nextpossibleBidAmount - (biddingIncrementalAmount ? biddingIncrementalAmount : latestBidCenterData?.bidIncrement);

    const effectiveIncrementMultiplier = latestBidCenterData?.incrementMultiplier || bidCenterData?.incrementMultiplier || bidCenterData?.customBidIncrementMultiplier;

    if (effectiveIncrementMultiplier && (parseInt(bidAmount) - parseInt(CHB)) % effectiveIncrementMultiplier != 0) {

      if (latestBidCenterData?.activeBidRefinementEnabled === true &&
        parseInt(bidAmount) === lowerThresholdAmount) {

      } else {

        if (latestBidCenterData?.activeBidRefinementEnabled === true &&
          latestBidCenterData?.currentHighestBid < lowerThresholdAmount &&
          parseInt(bidAmount) > lowerThresholdAmount) {

          errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
            "###MAX_BID_AMOUNT###",
            getFormatPrice(bidMaxLimit)
          );
          setvalidationError(
            errorMessage
          );
          dispatch(setPdpError(errorMessage))

        } else {

          errorMessage =
            "Please use $" +
            currencyFormatNew(effectiveIncrementMultiplier) +
            " increments";
          setvalidationError(
            "Please use $" +
            currencyFormatNew(effectiveIncrementMultiplier) +
            " increments"
          );
          dispatch(setPdpError("Please use $" +
            currencyFormatNew(effectiveIncrementMultiplier) +
            " increments"))

        }

      }

    } else if (bidAmount === 0 || bidAmount === "" || bidAmount === "$") {
      setvalidationError(cmsErrorMessages?.EMPTY_BID_AMOUNT);
      dispatch(setPdpError(cmsErrorMessages?.EMPTY_BID_AMOUNT))
      errorMessage = cmsErrorMessages?.EMPTY_BID_AMOUNT;
    } else if (Number(bidAmount) < bidMinLimit) {
      setvalidationError(
        cmsErrorMessages?.MIN_BID_AMOUNT.replace(
          "###MIN_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )
      );
      dispatch(setPdpError(cmsErrorMessages?.MIN_BID_AMOUNT.replace(
        "###MIN_BID_AMOUNT###",
        getFormatPrice(bidMinLimit)
      )))
      errorMessage = cmsErrorMessages?.MIN_BID_AMOUNT.replace(
        "###MIN_BID_AMOUNT###",
        getFormatPrice(bidMinLimit)
      );
    }
    // else if (
    //   Number(bidAmount) > bidMaxLimit &&
    //   bidCenterData?.activeBidRefinementEnabled !== true  ////changed as part of 110 bidwizard sheer
    // ) {
    else if (
      Number(bidAmount) > bidMaxLimit
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMaxLimit)
        )
      );
      dispatch(setPdpError(cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMaxLimit)
      )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMaxLimit)
      );
      return errorMessage;
    } else if (Number(bidAmount) > maximumPossibleBidAmount) {
      setvalidationError(cmsErrorMessages?.MAX_BID_REACHED);
      dispatch(setPdpError(cmsErrorMessages?.MAX_BID_REACHED))
      errorMessage = cmsErrorMessages?.MAX_BID_REACHED;
    } else {
      setvalidationError("");
      dispatch(setPdpError(""))
      errorMessage = null;
    }

    if (
      latestBidCenterData?.activeBidRefinementEnabled === true &&
      latestBidCenterData?.highestBidAmount >= lowerThresholdAmount &&
      latestBidCenterData?.nextpossibleBidAmount < upperThresholdAmount &&
      bidAmount > bidMinLimit + lowerThresholdIncrementMultiplier
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
        )
      );
      dispatch(setPdpError(cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
      )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
      );
    } else if (
      latestBidCenterData?.activeBidRefinementEnabled === true &&
      latestBidCenterData?.highestBidAmount >= upperThresholdAmount &&
      bidAmount > bidMinLimit + upperThresholdIncrementMultiplier
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )
      );
      dispatch(setPdpError(cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMinLimit)
      )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMinLimit)
      );
    } else if (
      latestBidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >=
      parseInt(
        lowerThresholdAmount +
        (nextpossibleBidAmount % biddingIncrementalAmount) +
        biddingIncrementalAmount
      ) &&
      nextpossibleBidAmount <=
      lowerThresholdAmount +
      (nextpossibleBidAmount % biddingIncrementalAmount)
    ) {
      /* bid amount in the border of lower threshhold  added equal to for HUBZ-3027*/
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        )
      );
      dispatch(setPdpError("The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        )))
      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        );

    } else if (
      latestBidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >
      parseInt(
        upperThresholdAmount +
        (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
      ) &&
      nextpossibleBidAmount <
      upperThresholdAmount +
      (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
    ) {
      /* bid amount in the border of upper threshhold */
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        )
      );
      dispatch(setPdpError("The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        )))
      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        );
    } else if (
      latestBidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >
      parseInt(upperSlab - upperThresholdIncrementMultiplier) +
      parseInt(upperThresholdIncrementMultiplier) *
      activeConfigData?.upperThreshHoldMaxCount
    ) {
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab - upperThresholdIncrementMultiplier) +
          parseInt(upperThresholdIncrementMultiplier) *
          activeConfigData?.upperThreshHoldMaxCount
        )
      );
      dispatch(setPdpError("The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab - upperThresholdIncrementMultiplier) +
          parseInt(upperThresholdIncrementMultiplier) *
          activeConfigData?.upperThreshHoldMaxCount
        )))

      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        );

      // setBidAmountError(true);

    }

    return errorMessage;

  };


  const getFormatPrice = (amnt) => {
    if (amnt?.length === 0 || isNaN(amnt)) {
      return "";
    }
    return amnt?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };

  const getFormattedPrice = (amount) => {
    return getFormatPrice(amount ? amount : bidAmount);
  };

  const decrement = () => {
    setvalidationError("");
    dispatch(setPdpError(""))
    console.log('bidMaxLimit ', bidMaxLimit);
    console.log('bidMinLimit ', bidMinLimit);

    if (bidAmount > bidMinLimit) {

      trackButtonClick({
        eventName: "bid_center_decrement_click",
        eventCategory: "NEW-PDP",
        eventSource: "on decrement button click",
        eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Decrement`
      })

      if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        bidCenterData?.currentHighestBid >= lowerThresholdAmount &&
        bidCenterData?.currentHighestBid < upperThresholdAmount
      ) {
        if (bidAmount > bidMaxLimit) {
          setBidAmount(parseInt(nextpossibleBidAmount));
        } else {

          const CHB = nextpossibleBidAmount - lowerThresholdIncrementMultiplier;

          const remainder =
            (parseInt(bidAmount) - parseInt(CHB)) % parseInt(lowerThresholdIncrementMultiplier);

          if (remainder === 0) {
            setBidAmount(
              parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier));
            console.log('CHB ', CHB);
            console.log('remainder ', remainder);
            console.log('parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier) ', parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier));
          } else {
            setBidAmount(parseInt(bidAmount) - remainder);

            console.log('CHB ', CHB);
            console.log('remainder ', remainder);
            console.log('parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier) ', parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier));

          }

          // setBidAmount(
          //   parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier)
          // );
          setBidIncrementCount(bidIncrementCount - 1);

        }

      } else if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        bidCenterData?.currentHighestBid >= upperThresholdAmount
      ) {

        const CHB = nextpossibleBidAmount - upperThresholdIncrementMultiplier;

        const remainder =
          (parseInt(bidAmount) - parseInt(CHB)) % parseInt(upperThresholdIncrementMultiplier);

        if (remainder === 0) {
          setBidAmount(
            parseInt(bidAmount) - parseInt(upperThresholdIncrementMultiplier)
          );
        } else {
          setBidAmount(parseInt(bidAmount) - remainder);

        }

        // setBidAmount(
        //   parseInt(bidAmount) - parseInt(upperThresholdIncrementMultiplier)
        // );
        setBidIncrementCount(bidIncrementCount - 1);
      } else {

        const CHB = nextpossibleBidAmount - biddingIncrementalAmount;


        if ((parseInt(bidAmount) - parseInt(CHB)) % bidCenterData?.incrementMultiplier != 0) {

          const remainder = (parseInt(bidAmount) - parseInt(CHB)) % bidCenterData?.incrementMultiplier;
          setBidAmount(parseInt(bidAmount) - remainder);
        }
        else if (bidAmount > bidMaxLimit) {
          setBidAmount(parseInt(nextpossibleBidAmount));
        } else {
          setBidAmount(parseInt(bidAmount) - parseInt(biddingIncrementalAmount));
        }

        // if (bidAmount > bidMaxLimit) {
        //   setBidAmount(parseInt(nextpossibleBidAmount));
        // } else {
        //   setBidAmount(parseInt(bidAmount) - parseInt(biddingIncrementalAmount));
        // }

      }
    }

    else {
      setBidAmount(parseInt(nextpossibleBidAmount));
      // validateBidMinMaxPriceError();
    }
  };

  const increment = () => {
    setvalidationError("");
    dispatch(setPdpError(""))
    if (bidAmount < bidMaxLimit) {
      trackButtonClick({
        eventName: "bid_center_increment_click",
        eventCategory: "NEW-PDP",
        eventSource: "on increment button click",
        eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Increment`
      })

      if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) >= lowerThresholdAmount &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) < upperThresholdAmount
      ) {
        if (bidAmount < (bidMinLimit + lowerThresholdIncrementMultiplier)) {
          if (bidAmount < bidMinLimit) {
            setBidAmount(bidMinLimit);

          } else {

            const CHB = nextpossibleBidAmount - lowerThresholdIncrementMultiplier;

            const remainder =
              (parseInt(bidAmount) - parseInt(CHB)) %
              lowerThresholdIncrementMultiplier;
            const adjustment = lowerThresholdIncrementMultiplier - remainder;
            setBidAmount(parseInt(bidAmount) + adjustment);

            // setBidAmount(
            //   parseInt(bidAmount) + parseInt(lowerThresholdIncrementMultiplier)
            // );
            setBidIncrementCount(bidIncrementCount + 1);
          }

        } else {
          validateBidMinMaxPriceError();
        }
      } else if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) >= upperThresholdAmount
      ) {
        if (
          bidIncrementCount < 0 &&
          (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
            latestBidCenterData?.nextpossibleBidAmount) > upperThresholdAmount
        ) {

          const CHB = nextpossibleBidAmount - upperThresholdIncrementMultiplier;

          const remainder =
            (parseInt(bidAmount) - parseInt(CHB)) %
            upperThresholdIncrementMultiplier;
          const adjustment = upperThresholdIncrementMultiplier - remainder;
          setBidAmount(parseInt(bidAmount) + adjustment);

          // setBidAmount(
          //   parseInt(bidAmount) + parseInt(upperThresholdIncrementMultiplier)
          // );
          setBidIncrementCount(parseInt(bidIncrementCount) + 1);
        } else {
          validateBidMinMaxPriceError();
        }
      } else {
        if (bidAmount < bidMinLimit) {
          setBidAmount(parseInt((auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
            latestBidCenterData?.nextpossibleBidAmount)));
        } else {
          const CHB = nextpossibleBidAmount - biddingIncrementalAmount;

          if ((parseInt(bidAmount) - parseInt(CHB)) % bidCenterData?.incrementMultiplier != 0) {


            const remainder = (parseInt(bidAmount) - parseInt(CHB)) % bidCenterData?.incrementMultiplier;
            const adjustment = bidCenterData?.incrementMultiplier - remainder;
            setBidAmount(parseInt(bidAmount) + adjustment);

          } else {

            if (parseInt(bidAmount) < bidMinLimit) {
              setBidAmount(bidMinLimit)

            } else {
              const remainder =
                (parseInt(bidAmount) - parseInt(CHB)) %
                biddingIncrementalAmount;
              const adjustment = biddingIncrementalAmount - remainder;
              setBidAmount(parseInt(bidAmount) + adjustment);


              // setBidAmount(parseInt(bidAmount) + parseInt(biddingIncrementalAmount));
            }

          }
        }
      }
    } else {
      validateBidMinMaxPriceError();
    }
  };

  const handleOwnItNow = async () => {
    setIsVerificationGoingForOwnitNow(true);
    try {
      if (profileInfo?.userEmailId) {
        const isSessionValid = await isValidSession();
        const isValid = isSessionValid.data?.isValidSession;

        const phoneNo = profileInfo?.primaryPhone;


        if (isValid === "Y") {

          trackButtonClick({
            eventName: "own_it_now_aucn",
            eventCategory: "NEW-PDP",
            eventSource: "on own it now click",
            eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Own it now- AUCN`,
          });

          const res = await isPhoneNoVerified(profileInfo?.primaryPhone);


          if (res?.data?.data) {

            dispatch(enableOwnItNow(true));
            if (!(validationError?.length > 0)) {
              trackButtonClick({
                eventName: "user_action_type_check",
                eventCategory: "NEW-PDP",
                eventSource: "on own it now click",
                eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Place Bid`
              })

              const isAuthorised = await isUserAuthorised(
                pdpInitData?.propertyDetails?.listingId
              );

              trackApiCall({
                eventName: "user_action_type_check_success",
                eventCategory: "NEW-PDP",
                eventSource: "on own it now click",
                eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Place Bid`,
                eventParams: { success: true }
              })

              setIsVerificationGoingForOwnitNow(false);

              if (isAuthorised.message === "USER_NOT_ALLOWED_TO_BID") {
                setAlertText(
                  "You cannot place another bid as you are the current highest bidder."
                );
                setShowAlert(true);
              } else {
                dispatch(setSelectedBidAmount(bidAmount));


                if (propCategory === "COMMERCIAL" && status !== "PACT") {


                  if (isNDAAccepted === "Y") {
                    dispatch(setRedirectionAction(""));
                    navigate("/bid");
                  } else {
                    setShowNDA(true);
                  }


                } else {
                  dispatch(setRedirectionAction(""));
                  navigate("/bid");
                }
              }
            }
          } else {
            const isPhoneVerified = res?.data?.data;


            const data = { phoneNo, verificationType: "sms" };

            if (!isPhoneVerified) {
              dispatch(
                showOtpModal({
                  phoneNumber: profileInfo?.primaryPhone,
                  redirectScreen: "PDP",
                })
              );
              dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
              const response = await sendVerificationCode(data);

              if (
                response?.status === "FAILURE" &&
                response?.errorCode.startsWith("Invalid")
              ) {
              }
            }
          }
        } else {
          dispatch(setRedirectionAction('handleOwnItNow'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(true))
          // dispatch(setLoginCallback(() => handleOwnItNow));
        }
      } else {
        dispatch(setRedirectionAction('handleOwnItNow'));
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
        dispatch(setShowSessionMsg(false))
      }
    } catch (error) {
    } finally {
      setIsVerificationGoingForOwnitNow(false);
    }
  };
  const hanldePlaceBid = async (type) => {

    if (bidCenterData !== undefined && type !=="registerCompleted") {

      if (latestBidCenterData.placeBackupBidButton !== true && status !== "PACT") {
        const validationErr = validateBidMinMaxPriceError();
        if (validationErr) {
          return;
        }
      }

      setBidActionType(type)

      setIsVerificationGoing(true);



      try {
        if (profileInfo?.userEmailId) {
          const isSessionValid = await isValidSession();
          const isValid = isSessionValid.data?.isValidSession;

          const phoneNo = profileInfo?.primaryPhone;

          if (isValid === "Y") {


            // ⚠️ Do not remove, this is requried to pass updated data to otp verification screen
            // getUserProfile().then((response) => {
            //   const data = response?.data;
            //   dispatch(setProfileInfo(data));
            // });

            trackButtonClick({
              eventName: "place_bid_action",
              eventParams: { action_type: type },
              eventCategory: "NEW-PDP",
              eventSource:
                type === "placeBid"
                  ? "on place bid click"
                  : type === "placeBackupBid"
                    ? "on place backup bid click"
                    : type === "registerToBid"
                      ? "on register to bid click"
                      : type === "registerCompleted"
                        ? "on register completed click"
                        : "on place bid click",
              eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | ${type === "placeBid"
                ? "Place Bid"
                : type === "placeBackupBid"
                  ? "Place Backup Bid"
                  : type === "registerToBid"
                    ? "Register To Bid"
                    : type === "registerCompleted"
                      ? "Register Completed Preview"
                      : "Place Bid"
                }`,
            });


            const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
            setIsVerificationGoing(false);
            dispatch(enableOwnItNow(false));

            if (res?.data?.data) {
              if (!(validationError?.length > 0)) {
                trackButtonClick({
                  eventName: "user_action_type_check",
                  eventCategory: "NEW-PDP",
                  eventSource: "on place bid click",
                  eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Place Bid`
                })

                const isAuthorised = await isUserAuthorised(
                  pdpInitData?.propertyDetails?.listingId
                );

                trackApiCall({
                  eventName: "user_action_type_check_success",
                  eventCategory: "NEW-PDP",
                  eventSource: "on place bid click",
                  eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Place Bid`,
                  eventParams: { success: true }
                })

                if (isAuthorised.message === "USER_NOT_ALLOWED_TO_BID") {
                  setAlertText(
                    "You cannot place another bid as you are the current highest bidder."
                  );
                  setShowAlert(true);
                } else {
                  dispatch(setSelectedBidAmount(bidAmount));
                  if (propCategory === "COMMERCIAL" && status !== "PACT") {

                    if (isNDAAccepted === "Y") {
                      dispatch(setRedirectionAction(""));
                      navigate("/bid");
                    } else {
                      setShowNDA(true);
                    }

                  } else {
                    dispatch(setRedirectionAction(""));
                    navigate("/bid");
                  }
                }
              }
            } else {
              const isPhoneVerified = res?.data?.data;

              if (!isPhoneVerified) {
                dispatch(
                  showOtpModal({
                    phoneNumber: profileInfo?.primaryPhone,
                    redirectScreen: "PDP",
                    redirectionRequired: true,
                  })
                );
                dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
              }
            }
          } else {

            dispatch(setRedirectionAction('handlePlaceBid'));
            dispatch(setLoginModal(true));
            dispatch(setLoginTab("loginTab"));
            dispatch(setLoginCallLocation("Popup"));
            dispatch(setShowSessionMsg(true))
          }
        } else {
          dispatch(setRedirectionAction('handlePlaceBid'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(false))
        }
      } catch (error) {

      } finally {
        setIsVerificationGoing(false);
      }
    }

  };


  const saveProperty = async () => {
    // const isSessionValid = await isValidSession();
    // const isValid = isSessionValid.data?.isValidSession;
    // if (isValid === "Y") {
    //   navigate("/bid");
    // } else {
    //   dispatch(setLoginModal(true));
    //   dispatch(setLoginTab("loginTab"));
    //   dispatch(setLoginCallLocation("Popup"));
    // }
    //save codee
  };
  // !place best bid logic
  const place_BestBid = () => {
    try {
      setShowBestBidModal(true);
    } catch (error) {
    }
  };
  const openDynamicBiddingPopUp = () => {
    setShowDynamicBiddingPopUp(true);
    trackButtonClick({
      eventName: "dynamic_bidding",
      eventCategory: "NEW-PDP",
      eventSource: "learn about dynamic bidding click",
      eventLabel: `propertyId: ${pdpInitData?.propertyDetails?.propertyId
        }|listingId: ${pdpInitData?.propertyDetails?.listingId
        }|Foreclosure Property: ${isForeclosure ? "Yes" : "No"}`,
    });
  };

  const navigateToBidCountySite = () => {
    trackButtonClick({
      eventName: "bid_on_county_site",
      eventCategory: "NEW-PDP"
    })
  };

  const addtoFav = () => { };


  const navigateToPlaceBackUpOffer = async (listingId) => {
    // validateOfferMinMaxPriceError();

    // if (!offerAmount) {
    //   setvalidationError("Enter offer amount");
    //   return;
    // }
    // if (!(validationError)) {
    try {
      setIsVerificationGoing(true);
      if (profileInfo?.userEmailId) {

        const isSessionValid = await isValidSession();
        const isValid = isSessionValid.data?.isValidSession;

        const phoneNo = profileInfo?.primaryPhone;


        if (isValid === "Y") {
          trackButtonClick({
            eventName: "place_backup_offer_click",
            eventCategory: "NEW-PDP",
            eventSource: "on place backup offer click",
            eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
          });

          const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
          setIsVerificationGoing(false);

          if (res?.data?.data) {
            // if (!offerAmount) {
            //   return;
            // }
            //  if(!(validationError)){
            let offerType = "PLACE_BACKUP_OFFER";

            validateUserAction(offerType, listingId);

            // let offerType = "PLACE_BACKUP_OFFER"
            // const state = { listingId, userId: user.user.realbidUserId, offerAmount: offerCenterDetail?.listingPrice, offerType }
            // navigate("/offer", {
            //   state: state,
            // });
          } else {
            const isPhoneVerified = res?.data?.data;

            const data = { phoneNo, verificationType: "sms" };


            if (!isPhoneVerified) {
              dispatch(
                showOtpModal({
                  phoneNumber: profileInfo?.primaryPhone,
                  redirectScreen: "PDP",
                })
              );
              dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
              const response = await sendVerificationCode(data);

              if (
                response?.status === "FAILURE" &&
                response?.errorCode.startsWith("Invalid")
              ) {
              }
            }
          }
        } else {
          // setRedirectionAction("placeBackUpOffer");
          dispatch(setRedirectionAction('placeBackUpOffer'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(true))
          // dispatch(setLoginCallback(() => navigateToPlaceBackUpOffer));

        }
      } else {
        dispatch(setRedirectionAction('placeBackUpOffer'));
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
        dispatch(setShowSessionMsg(false))
      }
    } catch (error) {
    } finally {
      setIsVerificationGoing(false);
    }
    // }
  };

  const getBidHistoryDetails = async (id) => {

    trackButtonClick({
      eventName: "view_bid_history_chart",
      eventCategory: "NEW-PDP",
      eventSource: "on view all bids click",
      eventLabel: `listingId: ${id}`
    })

    const history = await getBidHistory(id);
    if (history) {
      setBidHistory(history?.data);

      setShowBidHistory(true);
    }
  };

  const handleRequestInformation = () => { };
  const saveTofav = () => { };

  const navigateToPlaceBackUpBid = () => {

    try {
      setShowBestBidModal(true);
    } catch (error) {
    }
  };

  const validateUserAction = async (offerType, listingId) => {
    const listingid = pdpInitData?.listingDetail?.businessListingId;
    // const offerListingId = offerCenterDetail?.listingId;
    const type = offerType === "PLACE_BACKUP_OFFER" ? "Place Backup Offer" : "Place Offer"

    trackButtonClick({
      eventName: "user_action_type_check",
      eventCategory: "NEW-PDP",
      eventSource: `on ${type} click`,
      eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
      eventParams: { action_type: type }
    })

    const response = await getUserAction(listingid);
    trackApiCall({
      eventName: "user_action_type_check_success",
      eventCategory: "NEW-PDP",
      eventSource: `on ${type} click`,
      eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | ${type}`,
      eventParams: { action_type: type }
    })

    if (response === true) {
      setAlertTitle(
        statusPayload?.hasHnb === "Y"
          ? "Place HnB Offer"
          : "Place Counter Offer"
      );
      setShowOfferAlert(true);
    } else {
      if (offerType === "PLACE_OFFER") {
        const state = {
          listingId,
          userId: userID,
          offerAmount: redirectionAmount,
          offerType,
        };
        dispatch(setOfferData(state))
        navigate("/offer", {
          state: state,
        });

      } else {
        const state = {
          listingId,
          userId: userID,
          offerAmount: offerCenterDetail?.minimumStartingOffer,
          offerType,
        };
        dispatch(setOfferData(state))
        navigate("/offer", {
          state: state,
        });

      }
    }
    setIsVerificationGoing(false);
    dispatch(setRedirectionAmount(""));
  };

  const placeOffer = async (listingId) => {
    validateOfferMinMaxPriceError();

    if (!redirectionAmount) {
      setvalidationError("Enter offer amount");
      dispatch(setPdpError("Enter offer amount"))
      setIsVerificationGoing(false);
      return;
    }
    if (!validationError) {
      try {
        setIsVerificationGoing(true);
        if (profileInfo?.userEmailId) {
          const isSessionValid = await isValidSession();
          const isValid = isSessionValid.data?.isValidSession;

          const phoneNo = profileInfo?.primaryPhone;

          if (isValid === "Y") {
            trackButtonClick({
              eventName: "place_offer_click",
              eventCategory: "NEW-PDP",
              eventSource: "on place offer click",
              eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
            });

            const res = await isPhoneNoVerified(profileInfo?.primaryPhone);

            if (res?.data?.data) {
              let offerType = "PLACE_OFFER";

              validateUserAction(offerType, listingId);

              // let offerType = "PLACE_OFFER"

              // const state = { listingId, userId: user.user.realbidUserId, offerAmount: offerAmount, offerType }
              // navigate("/offer", {
              //   state: state,
              // });
            } else {
              const isPhoneVerified = res?.data?.data;

              const data = { phoneNo, verificationType: "sms" };

              if (!isPhoneVerified) {
                setIsVerificationGoing(false);
                dispatch(
                  showOtpModal({
                    phoneNumber: profileInfo?.primaryPhone,
                    redirectScreen: "PDP",
                  })
                );
                dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
                const response = await sendVerificationCode(data);

                if (
                  response?.status === "FAILURE" &&
                  response?.errorCode.startsWith("Invalid")
                ) {
                }
              }
            }
          } else {

            dispatch(setRedirectionAction('placeOffer'));
            // dispatch(setRedirectionAmount(offerAmount));
            dispatch(setLoginModal(true));
            dispatch(setLoginTab("loginTab"));
            dispatch(setLoginCallLocation("Popup"));
            dispatch(setShowSessionMsg(true))
            //  dispatch(setLoginCallback(() => placeOffer));

          }
        } else {
          dispatch(setRedirectionAction('placeOffer'));
          // dispatch(setRedirectionAmount(offerAmount));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(false))
        }
      } catch (error) {
        setIsVerificationGoing(false);
      }
    } else {
      setIsVerificationGoing(false);
    }
  };

  const validateOfferMinMaxPriceError = (value) => {

    if (redirectionAmount === undefined) {
      setvalidationError(
        `Amount should be greater than $${getFormatPrice(offerMinLimit)}`
      );
      dispatch(setPdpError(`Amount should be greater than $${getFormatPrice(offerMinLimit)}`))
    } else if (redirectionAmount < offerMinLimit) {
      setvalidationError(
        `Amount should be greater than $${getFormatPrice(offerMinLimit)}`
      );
      dispatch(setPdpError(`Amount should be greater than $${getFormatPrice(offerMinLimit)}`))

    } else if (redirectionAmount > offerMaxLimit) {
      setvalidationError(
        `Amount should be less than $${getFormattedPrice(offerMaxLimit)}`
      );
      dispatch(setPdpError(`Amount should be less than $${getFormattedPrice(offerMaxLimit)}`))

    } else {
      setvalidationError("");
      dispatch(setPdpError(""))
    }
  };

  const handleOfferAmountChange = (e) => {
    const text = e.target.value;

    if (text) {
      var amnt = text?.replace("$", "");
      // setOfferAmount(amnt?.toString().replace(/,/g, ""));
      dispatch(setRedirectionAmount(amnt?.toString().replace(/,/g, "")));
    }
    setvalidationError("");
    dispatch(setPdpError(""))
  };

  const handleBidAmountChange = (value) => {
    const text = value;
    if (text === "") {
      setBidAmount("");
    } else {
      var amnt = text.replace("$", "");
      setBidAmount(amnt?.toString().replace(/,/g, ""));
    }
    setvalidationError("");
    dispatch(setPdpError(""))
  };


  const renderBidCenterForActiveAuction = () => {
    return (
      <div style={{ height: "auto", minHeight: "420x" }}>
        {statusPayload.isActiveAuction && listingType === "AUCN" && (
          <>

            <>
              {/* Commercial layout: "Auction Ends In" with clock icon, timer left-aligned, then stacked label+amount */}
              {propCategory === "COMMERCIAL" ? (
                <>
                  <div className="commercial-bid-card__timer-section" style={{ backgroundColor: '#F8F9FA', borderRadius: '6px 6px 6px 6px', marginBottom:20, padding: '17px 20px 17px 20px' }} role="region" tabIndex="0">
                    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '-12px' }}>
                      <span style={{ fontSize: '18px', fontWeight: 600, color: '#000', lineHeight:"27px" }}>Auction Ends In</span>
                      <img src="/assets/images/pdp/clock.png" alt="" style={{ width: 20, height: 20 }} />
                    </div>
                    <CountdownTimer
                      shouldShowLabel="Y"
                      autoExtendConfig={autoExtendConfig}
                      until={auctionDetails?.auctionTimeLeft ? auctionDetails?.auctionTimeLeft : latestBidCenterData?.auctionTimeLeft}
                      onTimerEnd={() => {
                        setHasTimerEnded(true);
                      }} />
                    {/* Auction End Date */}
                    {(() => {
                      const ld = pdpInitData?.listingDetail;
                      const endDate = ld?.dateFormattedListingEndDate;
                      const endTime = ld?.timeFormattedListingEndTime;

                      // If formatted fields are available, use them
                      if (endDate) {
                        return (
                          <div style={{ padding: '0px 0px', marginLeft:"4px", marginTop: '0px', marginBottom:'20px' }}>
                            <span style={{ fontSize: '14px', fontWeight: 700, color: '#48525B', display: 'block', marginBottom: '2px', lineHeight:'22px' }}>Auction End Date:</span>
                            <span style={{ fontSize: '14px', fontWeight: 400, color: '#48525B', lineHeight:'22px' }}>
                              {(() => {
                                try {
                                  const parsed = new Date(endDate);
                                  if (!isNaN(parsed.getTime())) {
                                    const formatted = parsed.toLocaleDateString('en-US', { timeZone: 'America/New_York', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
                                    return `${formatted}${endTime ? ` at ${endTime}` : ''}`;
                                  }
                                } catch (e) { /* fallback below */ }
                                return `${endDate}${endTime ? ` at ${endTime}` : ''}`;
                              })()}
                            </span>
                          </div>
                        );
                      }

                      // Fallback: compute from auctionEndTime (Redux) or listingEndTime
                      const timestamp = auctionDetails?.auctionEndTime || ld?.listingEndTime || latestBidCenterData?.listingEndTime;
                      if (timestamp) {
                        const d = new Date(timestamp);
                        if (!isNaN(d.getTime())) {
                          const formatted = d.toLocaleDateString('en-US', {
                            timeZone: 'America/New_York',
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                          }) + ' at ' + d.toLocaleTimeString('en-US', {
                            timeZone: 'America/New_York',
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: true,
                          });
                          return (
                            <div style={{ padding: '0px 4px', marginLeft:'4px', marginTop: '0px', marginBottom:'-10px' }}>
                              <span style={{ fontSize: '14px', fontWeight: 700, color: '#48525B', display: 'block', marginBottom: '2px', lineHeight:'22px' }}>Auction End Date:</span>
                              <span style={{ fontSize: '14px', fontWeight: 400, color: '#48525B', lineHeight:'22px' }}>{formatted}</span>
                            </div>
                          );
                        }
                      }
                      return null;
                    })()}
                  </div>
                  <div style={{paddingLeft:33}}>
                    <p style={{ fontSize: '12px', color: '#48525B', marginBottom: '4px' }} tabIndex="0">
                      {getPrice().label || 'Current High Bid'}
                    </p>
                    <h3 style={{ fontSize: '36px', fontWeight: 600, color: '#000', margin: 0 }} tabIndex="0">
                      {getPrice().amount}
                    </h3>
                  </div>
                </>
              ) : (
                <>
              <div className="bid-center-header" role="region" tabIndex="0">
                <div className="d-flex justify-content-center">

                  <CountdownTimer
                    shouldShowLabel="Y"
                    until={auctionDetails?.auctionTimeLeft ? auctionDetails?.auctionTimeLeft : latestBidCenterData?.auctionTimeLeft}
                    autoExtendConfig={autoExtendConfig}
                    onTimerEnd={() => {
                      setHasTimerEnded(true);
                      // Handle timer end - refresh data, show message, etc.
                    }} />

                </div>
              </div>
              {getPrice().label === "Starting Bid" && (
                <>
                  <div className="d-flex flex-column align-items-center pt-4">
                    <h3
                      className="text-center bid-center-price-value fs-48"
                      tabIndex="0"
                      style={{ width: "auto" }}
                    >
                      {getPrice().amount}
                    </h3>
                    <p
                      className="text-center bid-center-price-heading pt-1 starting-bid-color mt8"
                      tabIndex="0"
                      style={{ width: "auto" }}
                    >
                      {getPrice().label}
                    </p>
                  </div>
                </>
              )}
              {getPrice().label !== "Starting Bid" && (
                <div className="d-flex justify-content-between pt20 prpl20">
                  <div
                    className="text-center bid-center-price-heading"
                    style={{ width: "auto" }}
                  >
                    <p className="mb-0" tabIndex="0">{getPrice().label}</p>
                    {user?.isUserLoggedIn === false && (
                      <>
                        <a
                          href={getPropertyURL(`/property/${pdpInitData?.propertyDetails?.listingId || pdpInitData?.propertyDetails?.propertyId}`, pdpInitData?.propertyDetails?.commonAttributes?.propCategory, pdpInitData?.propertyDetails?.commonAttributes?.status)}
                          target="_blank"
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch(setLoginModal(true));
                            dispatch(setLoginTab("loginTab"));
                            dispatch(setLoginCallLocation("Popup"));
                          }}
                          className="open-bid-history-btn pt5 pb10 d-block"
                        >
                          Log In to view all bids{" "}
                        </a>
                      </>
                    )}
                    {user?.isUserLoggedIn &&
                      propCategory !== "COMMERCIAL" &&
                      bidCenterData?.totalBidsOnListings > 0 && (
                        <>
                          <a
                            href={getPropertyURL(`/property/${pdpInitData?.propertyDetails?.listingId || pdpInitData?.propertyDetails?.propertyId}`, pdpInitData?.propertyDetails?.commonAttributes?.propCategory, pdpInitData?.propertyDetails?.commonAttributes?.status)}
                            target="_blank"
                            onClick={(e) => {
                              e.preventDefault();
                              getBidHistoryDetails(
                                pdpInitData?.listingDetail
                                  ?.businessListingId
                              );
                            }} rel="noreferrer"
                          >
                            <p className="open-bid-history-btn pt5 pb10">
                              View All Bids{(auctionDetails.totalBids || bidCenterData?.totalBidsOnListings) ? ` : ${auctionDetails.totalBids || bidCenterData?.totalBidsOnListings}` : ""}
                            </p>{" "}
                          </a>
                        </>
                      )}
                  </div>
                  <h3
                    className="text-center bid-center-price-value"
                    tabIndex="0"
                    style={{ width: "auto" }}
                  >
                    {getPrice().amount}
                  </h3>
                </div>
              )}
                </>
              )}
            </>
          </>
        )}

        {/* Bid Increment row — only for active commercial */}
        {statusPayload.isActiveAuction && propCategory === "COMMERCIAL" && bidCenterData?.biddingIncrementalAmount > 0 && (
          <div className="d-flex justify-content-between align-items-center prpl35 pt10 pb10">
            <p className="text-left pdp-bid-deposit-data mb-0" tabIndex="0">Bid Increment:</p>
            <p className="text-right pdp-bid-deposit-value mb-0" tabIndex="0">
              {"$" + getFormatPrice(auctionDetails?.bidIncrement || bidCenterData?.biddingIncrementalAmount)}
            </p>
          </div>
        )}

        {/* Transaction Fee row — only for active commercial with valid buyerPremiumPercentage */}
        {statusPayload.isActiveAuction && propCategory === "COMMERCIAL" && bidCenterData?.buyerPremiumPercentage && bidCenterData.buyerPremiumPercentage !== "0" && Number(bidCenterData.buyerPremiumPercentage) > 0 && (
          <div className="d-flex justify-content-between align-items-center prpl35 pt10 pb10">
            <p className="text-left pdp-bid-deposit-data mb-0" tabIndex="0">Transaction Fee:</p>
            <p className="text-right pdp-bid-deposit-value mb-0" tabIndex="0">
              {parseFloat(bidCenterData.buyerPremiumPercentage) + "%"}
            </p>
          </div>
        )}

        {/* View All Bids row — only for active commercial */}
        {statusPayload.isActiveAuction && propCategory === "COMMERCIAL" && user?.isUserLoggedIn && bidCenterData?.totalBidsOnListings > 0 && (
          <div className="d-flex justify-content-between align-items-center prpl35 pt5 pb10">
            <a className="open-bid-history-btn" tabIndex="0"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                getBidHistoryDetails(pdpInitData?.listingDetail?.businessListingId);
              }}
            >View All Bids:</a>
            <a className="open-bid-history-btn" tabIndex="0"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                getBidHistoryDetails(pdpInitData?.listingDetail?.businessListingId);
              }}
            >
              {auctionDetails?.numberOfBids || bidCenterData?.totalBidsOnListings}
            </a>
          </div>
        )}

        <div className="">
          {statusPayload.isActiveAuction &&
            listingType === "AUCN" &&
            bidCenterData?.reservePriceEnabled === "Y" &&
            !pdpInitData?.propertySpecialDetails?.invrAprvlReqdProp &&
            propCategory !== "ABS" &&
            bidCenterData &&
            !bidCenterData.clientCodeRestrictedFlag &&
            propCategory === "COMMERCIAL" && (
              <div className="d-flex justify-content-center prpl20">
                {(auctionDetails?.reservePriceMet === 'Y' || bidCenterData?.reservePrice === 'Met') ? (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#DCFCE7', color: '#008236', borderRadius: '20px', padding: '6px 14px', fontSize: '14px', fontWeight: 500 }}>
                    <img src="/assets/images/pdp/reserveMet.png" alt="" style={{ width: 18, height: 18 }} /> Reserve Met
                  </span>
                ) : (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#FEE2E2', color: '#DC2626', borderRadius: '20px', padding: '6px 14px', fontSize: '14px', fontWeight: 500 }}>
                    Reserve Not Met
                  </span>
                )}
              </div>
            )}

          {showBid && !isPreviewProperty && propCategory !== 'COMMERCIAL' && (
            <Col
              xs={12}
              md={12}
              className="prpl20 col d-flex justify-content-between align-items-center" tabIndex="0"
            >
              <p
                className="text-left tdu pdp-bid-deposit-data"
                data-tooltip-id="bidDepositToolTip"
                data-tooltip-place="bottom"
              >
                Bid Deposit:
              </p>
              <Tooltip
                id="bidDepositToolTip"
                place="bottom"
                openOnClick={false}
                closeOnClick={true}
                clickable={true}
                // isOpen={isTooltipOpen}
                style={{ fontSize: 11, width: 300, zIndex: 9999 }}
                render={() => (
                  <div style={{ padding: '8px', fontSize: '11px', pointerEvents: 'auto' }} tabIndex="0">
                    A Bid Deposit authorization hold is required in order to place bids on a property. The Bid Deposit is a one-time hold authorized by you on your credit card prior to placing a bid. The actual value of the hold will be confirmed before placing the bid. On each applicable property, the buyer (or agent on buyer's behalf) will be required to authorize the hold on a credit card prior to placing a bid. If, after the end of the auction, you are the selected bidder (i.e. the bidder chosen by the seller to proceed with the purchase), then the hold will remain in place until we receive payment confirmation of the earnest money deposit. If you are not the selected bidder, the bid deposit hold will be released. For more details, please visit our{" "}
                    <span
                      onClick={() => {

                        window.open("/support");
                      }}
                      style={{ textDecoration: 'underline', cursor: 'pointer' }}
                      tabIndex="0"
                    >
                      FAQ's
                    </span>

                  </div>
                )}
              />

              <p className="text-right pdp-bid-deposit-value" tabIndex="0">
                Required
              </p>
            </Col>
          )}

          {shouldShowCashOnly && (propCategory !== 'COMMERCIAL') && (
            <Col
              xs={12}
              md={12}
              className="d-flex prpl20 pt10 pb10 col justify-content-between align-items-center"
            >
              <p
                xs={6}
                md={6}
                className="text-left tdu  pdp-bid-deposit-data"
                tabIndex="0"

                data-tooltip-id="cashOnlyToolTip"
                data-tooltip-place="bottom"
                data-tooltip-content="The Seller will consider conventional financing and cash offers."
              >
                Cash Only:
              </p>
              <p xs={6} md={6} className="text-left  pdp-bid-deposit-value" tabIndex="0">
                {" "}
                {isCashOnly ? " Yes" : " No"}{" "}
              </p>
              <Tooltip id="cashOnlyToolTip" place="bottom"

                style={{ fontSize: 11, width: 300, zIndex: 9999 }} />
            </Col>
          )}

          {(bidCenterData?.reservePriceEnabled === "Y" || propCategory === 'COMMERCIAL') && (
            propCategory === 'COMMERCIAL' ? (
              <Col
                xs={12}
                md={12}
                className="d-flex prpl35 col justify-content-between align-items-center"
                tabIndex="0"
              >
                <p xs={6} md={6} className="text-left pdp-bid-deposit-data mb-0" tabIndex="0">
                  Status:
                </p>
                {bidCenterData?.reserveMet || auctionDetails?.reservePriceMet === 'Y' ? (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#DCFCE7', color: '#008236', borderRadius: '4px', padding: '6px 14px', fontSize: '14px', fontWeight: 600 }}>
                    <img src="/assets/images/pdp/reserveMet.png" alt="" style={{ width: 16, height: 16 }} /> Reserve Met
                  </span>
                ) : (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#FEF3C7', color: '#D97706', borderRadius: '4px', padding: '6px 14px', fontSize: '14px', fontWeight: 600, lineHeight:"20px" }}>
                     <img src="/assets/images/pdp/reserveNoMet.png" alt="" style={{ width: 16, height: 16 }} />  Reserve Not Met
                  </span>
                )}
              </Col>
            ) : (
              <Col
                xs={12}
                md={12}
                className="d-flex prpl20  col justify-content-between align-items-center"
                tabIndex="0"
              >
                <p xs={6} md={6} className="fwb text-left  pdp-bid-deposit-data" tabIndex="0">
                  Reserve Price:
                </p>
                <p xs={6} md={6} className="text-left  pdp-bid-deposit-value" tabIndex="0">
                  {" "}
                  {bidCenterData?.reservePrice
                    ? bidCenterData?.reservePrice
                    : ""}{" "}
                </p>
              </Col>
            )
          )}

          {auctionDetails?.auctionTimeLeft !== null &&
            auctionDetails?.auctionTimeLeft < autoExtendConfig.autoExtendWindowSec &&
            hasTimerEnded && (

              <><div>
                <p className="fc-data p20" tabIndex="0">
                  Note: The seller may choose to negotiate with bidders even if the
                  reserve price isn't met.
                </p>
              </div><div>

                  <p className="fc-data p20 pt10" tabIndex="0">
                    This auction has ended. Hubzu's system is currently processing and sending all bid data to the seller for review. This page will refresh when the property status is updated.
                  </p>
                </div></>
            )}
        </div>

        {<>
          <Row xs={12} md={12} className="prpl20 pb35 pt10 mob-pb0 bid-amnt-conatiner">
            <Col xs={7} md={7}>
              <Col xs={12} md={12} className="d-flex align-items-start">
                <div className="bidAmountContainer" tabIndex="0">
                  <button
                    className="bidAmountContainerBtn col-md-2"
                    type="link"
                    onClick={decrement}
                    aria-label="decrement"
                  >
                    <FaMinus size={20} />
                  </button>

                  <input
                    className="col-md-8 bidAmountTxt"
                    tabIndex="0"
                    style={{
                      padding: 0,
                      border: "none",
                      background: "none",
                      textAlign: "center",
                    }}
                    type="text"
                    value={"$" + getFormattedPrice(bidAmount)}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^\d]/g, ""); // Remove non-digits
                      handleBidAmountChange(numericValue);
                    }}
                    // onChange={handleBidAmountChange}
                    maxLength={21}
                    aria-label="Bid amount"
                    onBlur={() => {
                      validateBidMinMaxPriceError();
                    }}
                  />
                  <button
                    className="bidAmountContainerBtn col-md-2"
                    type=""
                    data-bs-toggle=""
                    aria-label="increment"
                    onClick={increment}
                  >
                    <FaPlus size={20} />
                  </button>
                  {validationError ? (
                    <p style={{ color: "red", fontSize: 12, paddingTop: 5, marginBottom: 10, position: 'relative', zIndex: 1 }}>
                      {validationError}
                    </p>
                  ) : null}
                  {/* Learn about dynamic bidding - above Place Bid for residential only */}
                  {propCategory !== 'COMMERCIAL' && bidCenterData &&
                    (bidCenterData?.incrementStrategy ===
                      "DYNAMIC_BID_INCREMENT" ||
                      bidCenterData?.incrementStrategy ===
                      "VARIATION_BID_INCREMENT") && (
                      <div className="pt10 pb30 mb30 prpl20 ">
                        <p className="text-left pt0 pb20">
                          <Button
                            variant="link"
                            onClick={openDynamicBiddingPopUp}
                            style={{
                              padding: 0,
                              border: "none",
                              fontSize: "12px",
                              color: "#118bf4",
                            }}
                          >
                            {" "}
                            Learn about dynamic bidding
                          </Button>
                        </p>
                        <Modal
                          show={showDynamicBiddingPopUp}
                          onHide={() => setShowDynamicBiddingPopUp(false)}
                          size="lg"
                          centered
                          className="ht-modal"
                        >
                          <Modal.Header
                            closeButton
                            className="ht-modal-header-custom"
                          >
                            <Modal.Title className="ht-modal-title-custom">
                              <FaIcons.FaLightbulb />
                              Learn about dynamic bidding
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body className="p50">
                            Dynamic bidding factors in the property&apos;s value,
                            current bid amount, bidding activity and the auction
                            closing time to set the bid increment automatically.
                            No other factors are considered, and the bid
                            increments do not change based on the identity of the
                            Bidders, property location or any other user-specific
                            or subjective factors. Email alerts make it easy for
                            Bidders to keep up with these changes so they can make
                            bid adjustments, if necessary. Bidders can refer to
                            the property details page for the current information
                            regarding a property, including bid-increment updates.
                          </Modal.Body>
                        </Modal>
                      </div>
                    )}
                </div>
              </Col>
            </Col>

            <Col xs={5} md={5}>
              <button
                className="btn btn-thm-bidCenter center col-12 p-2"
                type=""
                onClick={() => hanldePlaceBid("placeBid")}
              >
                {isVerificationGoing ? (
                  <LoadingText text="Processing..." />
                ) : (
                  <LoadedText text="Place Bid" />
                )}
              </button>
            </Col>
          </Row>
          {/* Learn about dynamic bidding - below Place Bid for commercial only */}
          {propCategory === 'COMMERCIAL' && bidCenterData &&
                    (bidCenterData?.incrementStrategy ===
                      "DYNAMIC_BID_INCREMENT" ||
                      bidCenterData?.incrementStrategy ===
                      "VARIATION_BID_INCREMENT") && (
                      <div className="pb10 prpl35" style={{ paddingLeft: '35px !important' }}>
                        <p className="text-left pt0 pb0" style={{ marginBottom: 0 }}>
                          <Button
                            variant="link"
                            onClick={openDynamicBiddingPopUp}
                            style={{
                              padding: 0,
                              border: "none",
                              fontSize: "12px",
                              color: "#118bf4",
                            }}
                          >
                            {" "}
                            Learn about dynamic bidding
                          </Button>
                        </p>
                        <Modal
                          show={showDynamicBiddingPopUp}
                          onHide={() => setShowDynamicBiddingPopUp(false)}
                          size="lg"
                          centered
                          className="ht-modal"
                        >
                          <Modal.Header
                            closeButton
                            className="ht-modal-header-custom"
                          >
                            <Modal.Title className="ht-modal-title-custom">
                              <FaIcons.FaLightbulb />
                              Learn about dynamic bidding
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body className="p50">
                            Dynamic bidding factors in the property&apos;s value,
                            current bid amount, bidding activity and the auction
                            closing time to set the bid increment automatically.
                            No other factors are considered, and the bid
                            increments do not change based on the identity of the
                            Bidders, property location or any other user-specific
                            or subjective factors. Email alerts make it easy for
                            Bidders to keep up with these changes so they can make
                            bid adjustments, if necessary. Bidders can refer to
                            the property details page for the current information
                            regarding a property, including bid-increment updates.
                          </Modal.Body>
                        </Modal>
                      </div>
                    )}
        </>}


        {
          ownItNowEnabled &&
          bidCenterData?.ownitNowPrice !== "" &&
          bidCenterData?.ownitNowPrice !== 0 &&
          bidCenterData?.ownitNowPrice !== null &&
          bidCenterData?.ownitNowPrice !== "-" &&
          auctionDetails?.auctionTimeLeft !== null &&
          auctionDetails?.auctionTimeLeft > autoExtendConfig.autoExtendWindowSec &&
          !hasTimerEnded && (
            <div className="prpl20 pt20">
              <div class="bid-divider" />
              <p className="bid-or">Or</p>
              <p className="col-12 fz16 text-center end-auction-data m-0 p-2 end-aution-label">
                You can end the auction now for just
              </p>
              <p className="col-12 fz20 text-center end-aution-price">
                {"$" + getFormatPrice(bidCenterData?.ownitNowPrice)}
              </p>
              <button
                className="btn btn-thm-bidCenter center end-auction end-auction-cta"
                type=""
                onClick={() => handleOwnItNow()}
              >End the Auction Now
                {/* {isVerificationGoingForOwnitNow ? (
                  <LoadingText text="Processing..." />
                ) : (
                  <LoadedText text="End the Auction Now" />
                )} */}
              </button>
            </div>
          )
        }
      </div >
    );
  };

  const renderBidCenterForWFAAuction = () => {
    return (
      <div className="p15 wlst-bid-center" style={{ height: "auto" }}>
        <h2
          className="text-center pb20 bidCenterSubtitleHeading"
          style={{ marginTop: 0 }}
        >
          {getData().header?.toUpperCase()}
        </h2>

        <Col
          xs={12}
          md={12}
          className="d-flex  col justify-content-between align-items-center pb15"
        >
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            Approximate Start Date
          </p>
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            {bidCenterData?.dateFormattedListingStartDate}{" "}
          </p>
        </Col>

        <Col
          xs={12}
          md={12}
          className="d-flex  col justify-content-between align-items-center pb10"
        >
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            Approximate Start Time
          </p>
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            {bidCenterData?.timeFormattedListingStartTime}
          </p>
        </Col>

        <Col
          xs={12}
          md={12}
          className="d-flex  col justify-content-between align-items-center pb20"
        >
          <p xs={6} md={6} className="pdpBody3 mt8">
            {" "}
            Starting Bid
          </p>
          <p xs={6} md={6} className="startingBidAmnt">
            {getPrice().amount}{" "}
          </p>
        </Col>

        <button style={{marginBottom:20}}
          className={`btn btn-thm-bidCenter center ${onWatchList === 'Y' ? 'previewPropertyWatch' : 'btn-bid-fav'}`}
          type=""
          onClick={onSave}
        >
          {onWatchList === 'Y' ? "Remove From Favorites" : "Save This Property"}
        </button>
      </div>
    );
  };

  const renderBidCenterForFCWFA = () => {
    return (
      <div className="p30" style={{ height: "auto" }}>
        <h2
          className="text-center bidCenterSubtitleHeading"
          style={{ marginTop: 0 }}
        >
          SCHEDULED
        </h2>




        <>
          <div className="d-flex flex-column align-items-center mt30">
            <h3
              className="text-center bid-center-price-value fs-48"
              style={{ width: "auto" }}
            >
              {getPrice().amount}{" "}
            </h3>
            <p
              className="text-center bid-center-price-heading pt-1 starting-bid-color mt8"
              style={{ width: "auto", color: 'black' }}
            >
              Starting Bid
            </p>
          </div>
        </>


        <button
          className={`btn btn-thm-bidCenter mt30 center ${onWatchList === 'Y' ? 'previewPropertyWatch' : 'btn-bid-fav'}`}
          type=""
          onClick={onSave}
        >
          {onWatchList === 'Y' ? "Remove From Favorites" : "Save This Property"}
        </button>
      </div>
    );
  };
  const renderBidCenterForWLSTREO = () => {
    return (
      <div className="">
        <h1 className="text-center bidCenterSubtitleHeading pt20" tabIndex="0">Coming Soon</h1>
        <p className="pdpBody3 pl20 pr20 pb20 text-center" tabIndex="0">
          <a
            href={pdpInitData?.propertyDetails?.address?.stateLandingUrl}
            rel="noopener noreferrer"
            className="wlst-bid"
          >
            Click here{" "}
          </a>
          to browse properties near by.
        </p>
      </div>
    );
  };
   const renderBidCenterForWLST = () => {
    return (
      <div className="">
        <h1 className="text-center bidCenterSubtitleHeading pt20" tabIndex="0">Bid Center</h1>
        <p className="pdpBody3 pl20 pr20 pb20 text-center" tabIndex="0">
          This listing is currently unavailable.{' '}
          <a
            href={pdpInitData?.propertyDetails?.address?.stateLandingUrl}
            rel="noopener noreferrer"
            // className="wlst-bid"
            style={{color:"#1D83BE"}}
          >
            Click here{" "}
          </a>
          to browse properties nearby.
        </p>
      </div>
    );
  };
  // dispaly CA FC sale Property
  const renderCAFCSaleProperty = (details) => {
    return (
      <div className="prpl20 pt20 pb20">
        <h3 className="text-center bid-heading-ends" tabIndex="0">
          POST-AUCTION BID PERIOD
        </h3>
        <p className="text-center mb10 pdp-get-content" tabIndex="0">
          <p className="pdpTextBlack">Sale Date : {details.saleDate}</p>
          <p className="pdpTextBlack">Sale Price : {details.salePrice}</p>
        </p>
      </div>
    );
  };

  const renderBidCenter = () => {
    return (
      <div className="prpl20 pt20 pb20 under-review-bid-center">
        {listingType === "TRNL" || listingType === null ? (
          <h3 center style={{ margin: 10 }} className="bid-heading-ends" tabIndex="0">
            {getData().header}
          </h3>
        ) : (
          getHeader()
        )}

        {listingType === "TRNL" || listingType === null ? (
          <p
            size={15}
            lh={22}
            color={"black"}
            style={{ marginLeft: 10, marginRight: 10, marginBottom: 10 }}
            tabIndex="0"
          >
            {getData().content}
          </p>
        ) : (
          getContent()
        )}
        {showBid && !isPreviewProperty && propCategory !== 'COMMERCIAL' && (
          <Col
            xs={12}
            md={12}
            className="prpl20 col d-flex justify-content-between align-items-center"
          >
            <p
              className="text-left tdu pdp-bid-deposit-data"
              tabIndex="0"
              data-tooltip-id="bidDepositToolTip"
              data-tooltip-place="bottom"

            >
              Bid Deposit:
            </p>
            <Tooltip
              id="bidDepositToolTip"
              place="bottom"
              openOnClick={false}
              closeOnClick={true}
              clickable={true}
              // isOpen={isTooltipOpen}
              style={{ fontSize: 11, width: 300, zIndex: 9999 }}
              render={() => (
                <div style={{ padding: '8px', fontSize: '11px', pointerEvents: 'auto' }} tabIndex="0">
                  A Bid Deposit authorization hold is required in order to place bids on a property. The Bid Deposit is a one-time hold authorized by you on your credit card prior to placing a bid. The actual value of the hold will be confirmed before placing the bid. On each applicable property, the buyer (or agent on buyer's behalf) will be required to authorize the hold on a credit card prior to placing a bid. If, after the end of the auction, you are the selected bidder (i.e. the bidder chosen by the seller to proceed with the purchase), then the hold will remain in place until we receive payment confirmation of the earnest money deposit. If you are not the selected bidder, the bid deposit hold will be released. For more details, please visit our{" "}
                  <span
                    onClick={() => {

                      window.open("/support");
                    }}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    tabIndex="0"
                  >
                    FAQ's
                  </span>

                </div>
              )}
            />

            <p className="text-right pdp-bid-deposit-value" tabIndex="0">
              Required
            </p>
          </Col>
        )}

        {!isPreviewProperty && shouldShowCashOnly && (propCategory !== 'COMMERCIAL') && (
          <Col
            xs={12}
            md={12}
            className="d-flex prpl20 pt10 col justify-content-between align-items-center"
          >
            <p
              xs={6}
              md={6}
              className="text-left tdu pdp-bid-deposit-data"
              tabIndex="0"
              data-tooltip-id="cashOnlyToolTip"
              data-tooltip-place="bottom"
              data-tooltip-content="The Seller will consider conventional financing and cash offers."
            >
              Cash Only:
            </p>
            <p xs={6} md={6} className="text-left pdp-bid-deposit-value" tabIndex="0">
              {" "}
              {isCashOnly ? " Yes" : " No"}{" "}
            </p>
            <Tooltip id="cashOnlyToolTip" place="bottom"
              style={{ fontSize: 11, width: 300, zIndex: 9999 }} />
          </Col>
        )}
        {isPreview && (
          <div
            className={`btn btn-thm-bidCenter center ${onWatchList === 'Y' ? 'previewPropertyWatch' : 'btn-bid-fav'}`} tabIndex="0"
          >
            {/* <button onPress={onSave}> */}
            <h1 active tabIndex="0">
              {onWatchList === 'Y' ? "Remove From Favorites" : "Save This Property"}
            </h1>
            {/* </button> */}
          </div>
        )}
        <div>
          {/* {(bidCenterData?.bestBidAvailable ||
            bidCenterData?.sellerFinalNegotiationResponse
              ?.sellerFinalNegotiationAvailable) && (
            <div className="pt30">
              <button
                className="btn btn-thm-bidCenter center col-12"
                type=""
                onClick={navigateToPlaceBackUpBid}
              >
                {bidCenterData?.bestBidAvailable && user_info !== null
                  ? true
                  : false
                  ? "Place Best Bid"
                  : bidCenterData?.sellerFinalNegotiationResponse
                      ?.sellerFinalNegotiationAvailable
                  ? "Confirm Offer for $" +
                    getFormattedPrice(
                      bidCenterData?.sellerFinalNegotiationResponse
                        ?.solicitationAmount
                    )
                  : ""}
                Place Best Bid
              </button>

              <BestBidModal
                show={showBestBidModal}
                onHide={() => setShowBestBidModal(false)}
                listingId={pdpInitData?.listingDetail?.listingId}
              />
            </div>
          )} */}
          {(bidCenterData?.bestBidAvailable ||
            bidCenterData?.sellerFinalNegotiationResponse
              ?.sellerFinalNegotiationAvailable) && (
              <div className="pt30">
                <button
                  className="btn btn-thm center col-12"
                  tabIndex="0"
                  type=""
                  onClick={() => {
                    if (bidCenterData?.bestBidAvailable && profileInfo !== null) {
                      setShowBestBidModal(true);
                      trackButtonClick({
                        eventName: "place_best_bid_click",
                        eventCategory: "NEW-PDP",
                        eventSource: `on place best bid click`,
                        eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`
                      })
                    } else if (
                      bidCenterData?.sellerFinalNegotiationResponse
                        ?.sellerFinalNegotiationAvailable
                    ) {
                      setOpenConfirmOffer(true);
                      trackButtonClick({
                        eventName: "place_backup_bid_click",
                        eventCategory: "NEW-PDP",
                        eventSource: `on confirm offer click`,
                        eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`
                      })
                    }
                  }}
                >
                  {bidCenterData?.bestBidAvailable && profileInfo !== null
                    ? "Place Best Bid"
                    : bidCenterData?.sellerFinalNegotiationResponse
                      ?.sellerFinalNegotiationAvailable
                      ? "Confirm Offer for $" +
                      getFormattedPrice(
                        bidCenterData?.sellerFinalNegotiationResponse
                          ?.solicitationAmount
                      )
                      : ""}
                </button>

                {/* Best Bid Modal */}
                <BestBidModal
                  show={showBestBidModal}
                  onHide={() => setShowBestBidModal(false)}
                  listingId={pdpInitData?.listingDetail?.listingId}
                />

                {/* Confirm Offer Modal */}
                <ConfirmOffer
                  show={openConfirmOffer}
                  handleClose={() => setOpenConfirmOffer(false)}
                  listingId={pdpInitData?.propertyDetails?.listingId}
                // propertyCategory={pdpInitData?.listingDetail?.propCategory}
                />
              </div>
            )}

          {(isWatchProperty || statusPayload.isUpcoming) && (
            <div>
              <button className="btn btn-thm-bidCenter" style={{ width: 380}} tabIndex="0" onClick={onWatchList === 'Y' ? gotoFavourite : onSave} id="pdpAddSave">
                {onWatchList === 'Y' ? "Go to Favorites" : "Add To Favorites"}
              </button>
            </div>
          )}
          {/*{status.isActive && !status.hasHnb === 'Y' && (*/}
          {statusPayload.isActive &&
            !isWatchProperty &&
            offerType !== "PLACE_BACKUP_OFFER" && (
              <div>
                <div>
                  {!statusPayload?.isTraditional && (
                    <div>
                      <button tabIndex="0" onClick={onWatchList === 'Y' ? gotoFavourite : onSave} id="pdpAddSave">
                        {onWatchList === 'Y' ? "Go to Favorites" : "Add To Favorites"}
                      </button>
                    </div>
                  )}
                  {statusPayload.isTraditional &&
                    offerType !== "PLACE_OFFER" &&
                    offerType !== "WATCH_PROPERTY" && <></>}
                  {statusPayload.isTraditional &&
                    offerType === "PLACE_OFFER" && <></>}
                  {offerType !== "WATCH_PROPERTY" && <></>}
                </div>
                {ownItNowEnabled &&
                  bidCenterData?.ownItNowPrice !== "" &&
                  bidCenterData?.ownItNowPrice !== 0 &&
                  bidCenterData?.ownItNowPrice !== null &&
                  bidCenterData?.ownItNowPrice !== "-" && (
                    <>
                      <div containerWidth={fullWidth}>
                        <div />
                        <p tabIndex="0">or</p>
                        <div />
                      </div>
                      <div>
                        <button
                        // onPress={() => {
                        //   setOwnitNowClicked(true);
                        //   validateandContinue();
                        //   dispatch(updateIsOwnitnow(true));
                        // }}
                        >
                          <button active>
                            <h1 active ownitnow tabIndex="0">
                              End the Auction Now
                            </h1>
                          </button>
                        </button>
                        <p tabIndex="0">For ${getFormattedPrice(p)}</p>
                      </div>
                    </>
                  )}
                <p>
                  {bidCenterData?.ownItNowPrice ? (
                    <p>{bidCenterData?.ownItNowPrice}</p>
                  ) : null}
                </p>
              </div>
            )}
          {offerType !== "PLACE_OFFER" &&
            offerType !== "PLACE_BACKUP_OFFER" &&
            offerType !== "WATCH_PROPERTY" &&
            !isWatchProperty &&
            !bidCenterData?.bestBidAvailable &&
            !bidCenterData?.sellerFinalNegotiationResponse
              ?.sellerFinalNegotiationAvailable &&
            (isUnderReviewAuction ||
              isUnderContractAuction ||
              statusPayload.hasHnb === "Y") &&
            latestBidCenterData.placeBackupBidButton === true && (
              <div className="pt20 place-backup-bid-container">
                <button
                  className="btn btn-thm-bidCenter place-backup-bid center col-12 p-2"
                  tabIndex="0"
                  type=""
                  onClick={() => hanldePlaceBid("placeBackupBid")}
                >
                  {!statusPayload.isTraditional && "Place Backup Bid"}
                </button>
              </div>
              // </button>
            )}
          {offerType !== "PLACE_OFFER" &&
            !isWatchProperty &&
            statusPayload.isPreview && (
              <div>
                <button
                  className="btn btn-thm-bidCenter center col-12"
                  tabIndex="0"
                  onClick={onWatchList === 'Y' ? gotoFavourite : onSave}
                  id="pdpAddSave"
                >
                  {onWatchList === 'Y' ? "Go to Favorites" : "Add To Favorites"}
                </button>
              </div>
              //   </button>
            )}
          {propCategory === "NPL" && (
            //   <button onPress={() => navigateToLeadForm()}>
            <div>
              <button
                className="btn btn-thm-bidCenter center col-12"
                tabIndex="0"
                type=""
                onClick={handleRequestInformation}
              >
                Request Information
              </button>
            </div>
            //   </button>
          )}
          {offerType === "PLACE_BACKUP_OFFER" &&
            statusPayload.isTraditional && (
              //   <button onPress={() => navigateToPlaceBackUpOffer()}>
              <div>
                <button
                  className="btn btn-thm-bidCenter center col-12"
                  tabIndex="0"
                  type=""
                  onClick={() =>
                    navigateToPlaceBackUpOffer(offerCenterDetail?.listingId)
                  }
                >
                  Place Backup Offer
                </button>
              </div>
              //   </button>
            )}

          {countyBiddingEnabled === "Y" && (
            //   <button onPress={() => navigateToBidCountySite()}>
            <div>
              <button
                className="btn btn-thm-bidCenter center col-12"
                tabIndex="0"
                type=""
                onClick={navigateToBidCountySite}
              >
                Bid on County Site
              </button>
            </div>
            //   </button>
          )}
        </div>
      </div>
    );
  };
  // <div>

  const renderForeclosureView = () => {
    return (
      <ForeclosureView
        eventCenterDetail={pdpInitData?.eventCenterDetail}
        statusPayload={statusPayload}
        estimatedOpeningBid={
          pdpInitData?.propertyDetails?.detailedAttributes?.estimatedOpeningBid
        }
        propCategory={commonAttributes?.propCategory}
        status={commonAttributes?.status}
      />
    );
  };

  const renderBidCenterForCommercial = () => {
    return (
      <div style={{ height: "auto" }}>
        {listingType === "AUCN" && (
          <>
            {(bidCenterData?.auctionTimeLeft || latestBidCenterData?.auctionTimeLeft) &&
              (bidCenterData?.auctionTimeLeft || latestBidCenterData?.auctionTimeLeft) > autoExtendConfig.autoExtendWindowSec && (
                <div>
                  <div className="bid-center-header">
                    {/* <h3 className=" bid-heading-ends" tabIndex="0">
                      Auction Begins In
                    </h3> */}
                     <div className="d-flex justify-content-between align-items-center bid-heading-ends" style={{ marginBottom: '5px', paddingTop:'17px' }}>
                      <span style={{ fontSize: '18px', fontWeight: 600, color: '#000', lineHeight:"27px" }}>Auction Begins In</span>
                      <img src="/assets/images/pdp/clock.png" alt="" style={{ width: 20, height: 20 }} />
                    </div>
                    <div className="d-flex ">
                      <CountdownTimer
                        shouldShowLabel="N"
                        autoExtendConfig={autoExtendConfig}
                        until={
                          auctionDetails?.auctionTimeLeft
                            ? auctionDetails?.auctionTimeLeft
                            : latestBidCenterData?.auctionTimeLeft
                        }
                      />
                    </div>
                    {/* Auction Start Date */}
                    {(pdpInitData?.listingDetail?.dateFormattedListingStartDate || bidCenterData?.dateFormattedListingStartDate) && (
                      <div style={{ marginLeft: '4px', marginRight: '0px' }}>
                         <span style={{ fontSize: '14px', fontWeight: 700, color: '#48525B', display: 'block', marginBottom: '2px', lineHeight:'22px' }}>Auction Start Date:</span>

                        <span style={{ fontSize: '14px', fontWeight: 400, color: '#48525B', lineHeight:'22px' }}>
                          {(() => {
                            const dateStr = pdpInitData?.listingDetail?.dateFormattedListingStartDate || bidCenterData.dateFormattedListingStartDate;
                            const timeStr = pdpInitData?.listingDetail?.timeFormattedListingStartTime || bidCenterData?.timeFormattedListingStartTime;
                            // Parse MM/DD/YYYY without timezone issues
                            const parts = dateStr.split('/');
                            if (parts.length === 3) {
                              const d = new Date(parts[2], parts[0] - 1, parts[1]);
                              const formatted = d.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
                              return `${formatted}${timeStr ? ` at ${timeStr}` : ''}`;
                            }
                            return `${dateStr}${timeStr ? ` at ${timeStr}` : ''}`;
                          })()}
                        </span>
                      </div>
                    )}
                    {/* Fallback: show end date if start date not available */}
                    {/* {!bidCenterData?.dateFormattedListingStartDate && bidCenterData?.dateFormattedListingEndDate && (
                      <div style={{ background: '#f8f9fa', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '8px 12px', marginTop: '8px', marginLeft: '20px', marginRight: '20px' }}>
                        <span style={{ fontSize: '12px', fontWeight: 600, color: '#6B7280', display: 'block' }}>Auction Start Date:</span>
                        <span style={{ fontSize: '13px', fontWeight: 500, color: '#1a2332' }}>
                          {bidCenterData.dateFormattedListingEndDate}
                          {bidCenterData?.timeFormattedListingEndTime ? ` at ${bidCenterData.timeFormattedListingEndTime}` : ''}
                        </span>
                      </div>
                    )} */}
                  </div>
                  <div className=" pt25" style={{paddingLeft:33, paddingRight:33}}>
                     <p
                      className="bid-heading-ends-label mt8"
                      tabIndex="0"
                      style={{ width: "auto" }}
                    >
                      {getPrice().label}
                    </p>
                    <p
                      className="commercial-bid-amount"
                      tabIndex="0"
                      style={{ width: "auto" }}
                    >
                      {getPrice().amount}
                    </p>

                  </div>
                </div>
              )}

          </>
        )}
        <div className="">
          {bidCenterData?.reservePriceEnabled === "Y" && (
            <div className="d-flex justify-content-center mb-3">
              {(auctionDetails?.reservePriceMet === 'Y' || bidCenterData?.reservePrice === 'Met') ? (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#DCFCE7', color: '#008236', borderRadius: '20px', padding: '6px 14px', fontSize: '14px', fontWeight: 500 }}>
                  <img src="/assets/images/pdp/reserveMet.png" alt="" style={{ width: 18, height: 18 }} /> Reserve Met
                </span>
              ) : (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#FEE2E2', color: '#DC2626', borderRadius: '20px', padding: '6px 14px', fontSize: '14px', fontWeight: 500 }}>
                  Reserve Not Met
                </span>
              )}
            </div>
          )}
          <button
          id="commercial-register-bid-btn"
            className="btn btn-thm-bidCenter center col-12 p-2  register-bid-btn"
            tabIndex="0"
            type=""
            onClick={() =>

              hanldePlaceBid(
                 pdpInitData?.cifCompleted === 'Y'
                  ? "registerCompleted"
                  : "registerToBid"
              )
            }
          >
            { pdpInitData?.cifCompleted === 'Y'
              ? "Registration Completed"
              : "Register to Bid"}
          </button>
        </div>
      </div>
    );
  };

  const handlePACTNavigation = () => {
    getCommercialWatchProperty(propertyId).then(res => {

    });
    hanldePlaceBid(
      cifCompleted === 'Y'
        ? "registerCompleted"
        : "registerToBid"
    )
  }


   const renderBidCenterForPACTPreview = () => {
    return (
      <div style={{ height: "auto" }}>
        {listingType === "AUCN" && (
          <>
            {pdpInitData?.listingDetail?.previewPeriodEndAt !== null &&
              pdpInitData?.listingDetail?.previewPeriodEndAt > autoExtendConfig.autoExtendWindowSec && (
                <div>
                  <div className="bid-center-header">
                    <h3 className="text-center bid-heading-ends" tabIndex="0">
                        Auction  Begins In
                    </h3>
                    <div className="d-flex justify-content-center">
                      <CountdownTimer
                        shouldShowLabel="N"
                        autoExtendConfig={autoExtendConfig}
                        until={
                          auctionDetails?.previewPeriodEndAt
                            ? auctionDetails?.previewPeriodEndAt
                            : pdpInitData?.listingDetail?.previewPeriodEndAt
                        }
                      />

                    </div>
                    {}
                  </div>
                  <div className="pt25" style={{paddingLeft:33, paddingRight:33}}>
                    <p
                      className="text-center commercial-bid-amount"
                      tabIndex="0"
                      style={{ width: "auto" }}
                    >
                      {getPrice().amount}
                    </p>
                    {
                      getPrice().amount !== null &&
                      getPrice().amount !== '' &&
                       <p
                      className="text-center bid-heading-ends-label mt8"
                      tabIndex="0"
                      style={{ width: "auto" }}
                    >
                      {getPrice().label}
                    </p>
                    }

                  </div>
                </div>
              )}
          </>
        )}
        <div className=" mt-4">
          {bidCenterData?.reservePriceEnabled === "Y" && (
            <div className="d-flex justify-content-center mb-3">
              {(auctionDetails?.reservePriceMet === 'Y' || bidCenterData?.reservePrice === 'Met') ? (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#DCFCE7', color: '#008236', borderRadius: '20px', padding: '6px 14px', fontSize: '14px', fontWeight: 500 }}>
                  <img src="/assets/images/pdp/reserveMet.png" alt="" style={{ width: 18, height: 18 }} /> Reserve Met
                </span>
              ) : (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#FEE2E2', color: '#DC2626', borderRadius: '20px', padding: '6px 14px', fontSize: '14px', fontWeight: 500 }}>
                  Reserve Not Met
                </span>
              )}
            </div>
          )}
          <button
            className="btn btn-thm-bidCenter center col-12 p-2 mb-4 register-bid-btn"
            tabIndex="0"
            type=""
            onClick={() =>

              handlePACTNavigation()

            }
          >
            {cifCompleted === 'Y'
              ? "Registration Completed"
              : "Register to Bid"}
          </button>
        </div>
      </div>
    );
  };

  const renderPreviewBidCenter = () => {
    return (
      <div className="prpl20">
        <h2 className="text-center preview-title pt25 pb10" tabIndex="0">
          PREVIEW PROPERTIES
        </h2>

        <div className="pb30">
          <p className="text-left preview-data" style={{ width: "auto" }} tabIndex="0">
            Stay ahead of the market with Hubzu's Preview Properties. Find out
            what properties are scheduled to come to our site, keep track of the
            perfect home and prepare to make a bid or offer.
          </p>
        </div>

        <button
          className={`btn btn-thm-bidCenter center mb30 p-2 ${onWatchList === 'Y' ? 'previewPropertyWatch' : 'btn-bid-fav'}`}
          tabIndex="0"
          type=""
          onClick={onSave}
        >
          {onWatchList === 'Y'
            ? "Remove From Favorites"
            : "Save This Property"}
        </button>
      </div>
    );
  };


  const renderOfferDetails = () => {
    return (


      <div className="prpl20 pt20 pb20">

        {listingType === 'TRNL' || listingType === null ? (

          <h3
            className="text-center bid-heading-ends-offer"
            tabIndex="0"
            style={{ width: "auto" }}
          >
            {getData().header}
          </h3>

        ) : (
          getHeader()
        )}
        {listingType === 'TRNL' || listingType === null ? (
          <p
            className="text-center bid-heading-ends-offer-label"
            tabIndex="0"
            style={{ width: "auto" }}
          >
            {getData().content}
          </p>
        ) : (
          getContent()
        )}
        {offerType === "PLACE_OFFER" && statusPayload.isTraditional && (
          <>
            <p
              className="text-center commercial-bid-amount"
              tabIndex="0"
              style={{ width: "auto" }}
            >
              {getPrice().amount}
            </p>
            <p
              className="text-center bid-heading-ends-offer-Amount mt8"
              tabIndex="0"
              style={{ width: "auto" }}
            >
              {getPrice().label}
            </p>
          </>
        )}
        {/* {(offerCenterDetail?.hasHnB === "Y" &&  !isOfferApproved ) && (
          <>
            <h3 className="bid-heading-ends">HIGHEST & BEST PERIOD ENDED</h3>
            {getContent()}
          </>
        )} */}
        {/* {isOfferApproved && (
            <>
              <h3 className="bid-heading-ends">Offer Approved</h3>
              <p
                size={15}
                lh={22}
                color={"black"}
                style={{ marginBottom: 10 }}
                className="pdp-get-content"
              >
                {" "}
                Seller has approved offer terms and is proceeding with the sale.
              </p>
            </>
          )} */}
        {(isOfferApproved ||
          (offerCenterDetail?.listingPrice && !isFinancing) ||
          offerType === "PLACE_BACKUP_OFFER") &&
          (
            <Col
              xs={12}
              md={12}
              className="prpl20 col d-flex justify-content-between align-items-center"
              tabIndex="0"
            >
              <p
                xs={6}
                md={6}
                className="text-left fwb  pdp-bid-deposit-data mt10"
                tabIndex="0"
              >
                Listing Price:
                {/* <Tooltip id="bidDepositToolTip" style={{ width: 300 }} /> */}
              </p>
              <p xs={6} md={6} className="text-right  pdp-bid-deposit-value" tabIndex="0">
                {"$" + getFormatPrice(offerCenterDetail?.listingPrice)}
              </p>
            </Col>
          )}

        {offerCenterDetail?.hasHnB === 'Y' && !isOfferApproved && offerType !== "PLACE_BACKUP_OFFER" && offerType !== "PLACE_OFFER" && (propCategory !== 'COMMERCIAL') ?

          (isFinancing &&
            <Col
              xs={12}
              md={12}
              className="d-flex col justify-content-between align-items-center"
            >
              <p
                xs={6}
                md={6}
                className="pdp-financing-consider pl15"
                tabIndex="0"
              >
                Listing Price {"$" + getFormatPrice(offerCenterDetail?.listingPrice)}
              </p>
              <p
                xs={6}
                md={6}
                className="pdp-financing-consider pr15"
                tabIndex="0"
              >
                Financing Considered
              </p>

            </Col>)


          :

          <Col
            xs={12}
            md={12}
            className="d-flex prpl20  col justify-content-between align-items-center"
          >
            <p
              xs={6}
              md={6}
              className="text-left tdu  pdp-bid-deposit-data pt10"
              tabIndex="0"
              data-tooltip-id="cashOnlyToolTip"
              data-tooltip-place="bottom"
              data-tooltip-content="The Seller will consider conventional financing and cash offers."
            >
              Cash Only:
            </p>
            <p xs={6} md={6} className="text-left  pdp-bid-deposit-value">
              {" "}
              {isCashOnly ? " Yes" : " No"}{" "}
            </p>
            <Tooltip id="cashOnlyToolTip" place="bottom"
              style={{ fontSize: 11, width: 300, zIndex: 9999 }} />
          </Col>
        }

        {statusPayload.isTraditional && offerType === "PLACE_OFFER" && (
          <Row xs={12} md={12} className="mt10">
            <Col xs={12} md={7} className="">
              <div className="bidAmountContainer">
                <input
                  className="col-md-12 bidAmountTxt"
                  tabIndex="0"
                  style={{
                    padding: 0,
                    border: "none",
                    background: "none",
                    textAlign: "center",
                    height: "45px",

                  }}
                  type=""
                  id=""
                  value={
                    redirectionAmount ? "$" + getFormattedPrice(redirectionAmount) : ""
                  }
                  onChange={handleOfferAmountChange}
                  placeholder="Enter your amount"
                  // maxLength={bidMaxLength}
                  onBlur={() => {
                    validateOfferMinMaxPriceError();
                  }}
                />
              </div>
              {validationError ? (
                <p style={{ color: "red", fontSize: 12, paddingTop: 5 }}>
                  {validationError}
                </p>
              ) : null}
            </Col>

            <Col xs={12} md={5}>
              <button
                className="btn btn-thm-bidCenter center col-12 p-2"
                tabIndex="0"
                type=""
                onClick={() => placeOffer(offerCenterDetail?.listingId)}
              >
                {isVerificationGoing ? "Processing..." : "Place Offer"}
              </button>
            </Col>
          </Row>
        )}
        {offerType === "PLACE_BACKUP_OFFER" && statusPayload.isTraditional && (
          //   <button onPress={() => navigateToPlaceBackUpOffer()}>
          <div>
            <button
              className="btn btn-thm-bidCenter center col-12 p-2 mt10"
              tabIndex="0"
              type=""
              onClick={() =>
                navigateToPlaceBackUpOffer(offerCenterDetail?.listingId)
              }
            >
              Place Backup Offer
            </button>
          </div>
          //   </button>
        )}
        {offerCenterDetail?.hasHnB === "Y" &&
          offerType !== "PLACE_BACKUP_OFFER" &&
          offerType !== "PLACE_OFFER" && (
            <div>
              <button
                className={`btn btn-thm-bidCenter center p-2 mt10 dropdown ${onWatchList === 'Y' ? 'previewPropertyWatch' : 'btn-bid-fav'}`} tabIndex="0"
                onClick={onSave}
                id="pdpAddSave"
              >
                {onWatchList === 'Y' ? "Remove from Favorites" : "Add To Favorites"}
              </button>
            </div>
          )}
      </div>
    );
  };
  const renderTRNLWFA = () => {
    return (
      <div className="p30 " style={{ height: "auto" }}>
        <h2
          className="text-center bidCenterSubtitleHeading"
          style={{ marginTop: 0 }}
        >
          WAITING FOR LISTING
        </h2>




        <>
          <div className="d-flex flex-column align-items-center mt30">
            <h3
              className="text-center bid-center-price-value fs-48"
              style={{ width: "auto" }}
            >
              {getPrice().amount}{" "}
            </h3>
            <p
              className="text-center bid-center-price-heading pt-1 starting-bid-color mt8"
              style={{ width: "auto", color: 'black' }}
            >
              Listing Price
            </p>
          </div>
        </>

        {shouldShowCashOnly && (propCategory !== 'COMMERCIAL') && (
          <Col
            xs={12}
            md={12}
            className="d-flex prpl20 pt10 pb10 col justify-content-between align-items-center"
          >
            <p
              xs={6}
              md={6}
              className="text-left tdu  pdp-bid-deposit-data"
              tabIndex="0"

              data-tooltip-id="cashOnlyToolTip"
              data-tooltip-place="bottom"
              data-tooltip-content="The Seller will consider conventional financing and cash offers."
            >
              Cash Only:
            </p>
            <p xs={6} md={6} className="text-left  pdp-bid-deposit-value" tabIndex="0">
              {" "}
              {isCashOnly ? " Yes" : " No"}{" "}
            </p>
            <Tooltip id="cashOnlyToolTip" place="bottom"

              style={{ fontSize: 11, width: 300, zIndex: 9999 }} />
          </Col>
        )}

        <button
          className={`btn btn-thm-bidCenter mt30 mb30 center ${onWatchList === 'Y' ? 'previewPropertyWatch' : 'btn-bid-fav'}`}
          type=""
          onClick={onSave}
        >
          {onWatchList === 'Y' ? "Remove From Favorites" : "Save This Property"}
        </button>
      </div>
    );

  }

  const renderViews = () => {
    if (
      isForeclosure && !isCAFCSaleProperty &&
      (commonAttributes?.status === "SCHEDULED" ||
        commonAttributes?.status === "POSTPONED" ||
        commonAttributes?.status === "AUCTION_EVENT_ENDED" ||
        commonAttributes?.status === "CLEAR_TO_SALE") &&
      pdpInitData?.eventCenterDetail &&
      pdpInitData?.fcOnlineFlag !== "Y" &&
      !pdpInitData?.fcProxyBidEnabled

    ) {
      return renderForeclosureView();
    }
    // else if(isForeclosure && commonAttributes?.status === "SPND") {
    //   return renderCAFCSaleProperty(caFcSalePropertyDetails);
    // }

    if (listingType === "AUCN") {
      if (statusPayload.isActiveAuction === true) {
        return renderBidCenterForActiveAuction();
      } else if (status === "WFA" || status === 'WLST' || status === "PIFA") {

        if (status === "WFA" && isFcOnlineFlag === 'Y') {
          return renderBidCenterForFCWFA()
        }

        else {
          if( status === "PIFA"){
              return renderBidCenterForWLSTREO();
          }
          return renderBidCenterForWFAAuction();
        }

      }
      else if (status === "PACT") {
         if (propCategory === 'COMMERCIAL') {
          return renderBidCenterForCommercial();
         }else{
          return renderBidCenterForPACTPreview();
         }

      } else {
        return renderBidCenter();
      }
      return null;
    } else if (listingType === "TRNL") {
      if (status === "WFA") {
        return renderTRNLWFA();
      }
      if(status === "CANCEL"){
         return renderBidCenterForWLST();
      }
      return renderOfferDetails();
    } else {
      if (listingType === null) {
        if (isPreview ) {
          if(status === "PACT"){
            return renderBidCenterForPACTPreview();
          }else{
            return renderPreviewBidCenter();
          }
        } else if (isCAFCSaleProperty && caFcSalePropertyDetails !== null) {
          // check for ca fc sale property
          return renderCAFCSaleProperty(caFcSalePropertyDetails);
        } else {
          if(commonAttributes?.propCategory==="REO"){
            return renderBidCenterForWLSTREO();
          }else{
            return renderBidCenterForWLST();
          }
        }
      } else {
        return renderBidCenter();
      }
    }
  };
  const handleClose = () => {
    setShowAlert(false);
    setShowOfferAlert(false);
  };

  const handleNDAClose = () => {
    setShowNDA(false);
  };

  const handleNavigatioToMyOffer = () => {
    navigate("/my-shopper/myOffers");
  };



  const isHotProperty = (currentBidCount) => {
    // const minBidCountForHotProperty = cmsData?.config?.minBidCountForHotProperty || 5;

    const minBidCountForHotProperty = 5;
    return (
      pdpInitData?.propertySpecialDetails?.isHotProperty === 'Y' &&
      status === 'ACTV' &&
      currentBidCount > prevBidCount &&
      currentBidCount >= minBidCountForHotProperty
    );
  };



  return (
    <div style={{ position: 'relative' }}>
      {showModal && !useModalForSave && (
        <div className="pdp-saved-modal-position">
          <PDPSaveModal showModal={showModal} setShowModal={setShowModal} isBidCenter={true} />
        </div>
      )}



      <div className="">{renderViews()}</div>
      <BidAlertTextModal showAlert={showAlert} onClose={handleClose} alertText={alertText} />

      <Modal show={showOfferAlert} onHide={handleClose}>
        <Modal.Header closeButton className="license-title">
          <Modal.Title className="text-white roboreg">{alertTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="p-4 text-center roboreg" tabIndex="0">
            A seller counter/HnB is already placed, please place the Counter/HnB
            from My Offers
          </p>
          <div className="d-flex justify-content-center" tabIndex="0">
            <button
              className="no-btn"
              onClick={() => handleNavigatioToMyOffer()}
            >
              My Offers
            </button>
            <button className="no-btn" onClick={() => handleClose()}>
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>


      <BidHistoryModal
        show={showBidHistory}
        handleClose={() => setShowBidHistory(false)}
        bidHistory={bidHistory}
        propertyCategory={propCategory}
      />
      <NDAModel
        show={showNDA}
        handleClose={handleNDAClose}
        handleNDAccept={handleNDAccepted}
        userProfileData={profileInfo}
      />
    </div>
  );
};

export default memo(BidCenter);
